<template>
  <div>
     <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
     <v-snackbar :top="y === 'top'" v-model="errorSnackbar">
      {{errorText}}
      <v-btn color="primary" flat @click="errorSnackbar = false">X</v-btn>
    </v-snackbar>
    <loading :active.sync="LocationDetailLoading" :is-full-page="true" color="green"></loading>

    
    <v-card flat color="white">
      <v-toolbar flat color="white" class="pt-3">
        <h2>{{locationInfo.locationNetwork.name}}: {{locationInfo.locationDescription}}</h2>
      </v-toolbar>
      <v-divider></v-divider>

      <v-toolbar flat color="white">
        <v-tabs  div="tabs">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            href="#"
            v-model="tabs"
            v-for="tab in tabs"
            :key="tab.name"
            @click="setActiveTabName(tab.name)"
          >{{tab.displayName}}</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-divider></v-divider>
      <v-toolbar flat color="white" v-if="displayContents('summary')">
        <v-flex xs3 sm3 md4 lg3>
          <h3>
            Network Device Status:
            <v-chip
              v-if="locationInfo.locationNetwork.networkStatus==='Live'"
              small
              class="white--text"
              color="light-green"
            >Live</v-chip>
            <v-chip
              v-else-if="locationInfo.locationNetwork.networkStatus==='Planned'"
              small
              class="white--text"
              color="blue"
            >Planned</v-chip>
            <v-chip
              v-else-if="locationInfo.locationNetwork.networkStatus==='In Progress'"
              small
              class="white--text"
              color="orange"
            >In Progress</v-chip>
          </h3>
        </v-flex>
        <v-flex xs3 sm3 md4 lg3>
          <h3>
            Network Build Status:
            <v-chip
              v-if="locationInfo.locationNetwork.networkStatus==='Live'"
              small
              class="white--text"
              color="light-green"
            >Live</v-chip>
            <v-chip
              v-else-if="locationInfo.locationNetwork.networkStatus==='Planned'"
              small
              class="white--text"
              color="blue"
            >Planned</v-chip>
            <v-chip
              v-else-if="locationInfo.locationNetwork.networkStatus==='In Progress'"
              small
              class="white--text"
              color="orange"
            >In Progress</v-chip>
          </h3>
        </v-flex>
        <v-flex xs3 sm3 md4 lg3>
          <h3>
            Passive Install Status:
            <v-chip
              v-if="locationInfo.fibrePulled==true"
              small
              color="light-green"
              class="white--text"
              @click="updatePassiveInstallStatus()"
            >Complete</v-chip>
            <v-chip v-else small  color="red"
              class="white--text" @click="updatePassiveInstallStatus()">Incomplete</v-chip>
          </h3>
        </v-flex>
        <v-flex xs3 sm3 md4 lg3>
          <h3>
            Active Install Status:
            <v-chip
              v-if="locationInfo.equipmentInstalled==true"
              small
              color="light-green"
              class="white--text"
            >Complete</v-chip>
            <v-chip v-else small color="red"
              class="white--text" >Incomplete</v-chip>
          </h3>
        </v-flex>
      </v-toolbar>
      <v-divider></v-divider>
      <!-- <v-toolbar flat color="white">
        <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
      </v-toolbar>-->

      <v-dialog persistent v-model="addContactModal" max-width="900px">
        <v-card>
          <v-toolbar flat class="primary">
            <h1 class="headline white--text">ADD CONTACT TO LOCATION</h1>
          </v-toolbar>
          <v-toolbar flat color="white">
            <v-autocomplete
              clearable
              hide-no-data
              flat
              color="primary"
              v-model="editedItem.contactTypeId"
              :items="contactTypes"
              item-text="name"
              item-value="id"
              label="*Select Contact Type"
              class="pt-4"
              persistent-hint
            ></v-autocomplete>
            <v-spacer></v-spacer>
            <v-text-field
              v-show="editedItem.contactTypeId"
              v-model="searchContacts"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              max-width="50px"
              class="pa-3"
            ></v-text-field>
            <v-btn flat color="primary" @click="createContactModal=true">Create New Contact</v-btn>
          </v-toolbar>
          <v-data-table
            v-if="allContacts!==null"
            :search="searchContacts"
            v-show="editedItem.contactTypeId"
            :headers="contactHeaders"
            class="elevation-1"
            :rows-per-page-items="[10, 25, 50, 100]"
            :loading="loading"
            :items="allContacts"
            item-key="id"
            align-center
          >
            <template v-slot:items="props">
              <td class="justify-center layout px-0">
                <v-icon
                  class="mr-2"
                  @click="addLocationContact(props.item)"
                  color="primary"
                >add_circle_outline</v-icon>
                <!-- <v-icon small @click="deleteItem(props.item.id)">delete</v-icon> -->
              </td>
              <td class="text-xs-center">{{props.item.name}}</td>
              <td class="text-xs-center">{{props.item.surname}}</td>
              <td class="text-xs-center">{{props.item.idNumber}}</td>
              <td class="text-xs-center">{{props.item.mobileNumber}}</td>
              <td class="text-xs-center">{{props.item.telephoneNumber}}</td>
              <td class="text-xs-center">{{props.item.emailAddress}}</td>
            </template>
            <!-- <template v-slot:footer>
      <td :colspan="headers.length">
        <strong>table features to be put here like export Data to Excel</strong>
      </td>
            </template>-->
            <!-- Custom Row count and Paging text -->
            <template
              v-slot:pageText="props"
            >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
          </v-data-table>

          <v-card-actions class="justify-center layout px-0">
            <v-btn
              color="primary"
              round
              class="white--text"
              @click="addContactModal=false; fetchContactTypes();fetchCustomers()"
            >Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="createContactModal" max-width="750px">
        <v-card>
          <v-toolbar flat class="primary">
            <h1 class="headline white--text">ADD CONTACT</h1>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <h3 dark-grey--text>Personal Details</h3>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.name"
                    label="*First Name"
                    persistent-hint
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.surname"
                    label="*Surname"
                    persistent-hint
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.idNumber"
                    label="*RSA ID Number or Passport Number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    v-model="editedItem.contactTypeId"
                    :items="contactTypes"
                    item-text="name"
                    item-value="id"
                    label="*Contact Type"
                    persistent-hint
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <h3 dark-grey--text>Contact Details</h3>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.mobileNumber"
                    label="*Mobile Number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.telephoneNumber"
                    label="Telephone Number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <h3 dark-grey--text>Login Settings</h3>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.emailAddress"
                    prepend-icon="email"
                    label="*Email Address"
                    persistent-hint
                    type="email"
                    v-on:blur="checkEmail"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.password"
                    prepend-icon="security"
                    label="Password"
                  ></v-text-field>
                </v-flex>

               
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center layout px-0">
            <!-- <v-layout row> -->
              <v-btn color="primary" round class="white--text" @click="createContactModal=false">Cancel</v-btn>
            <v-btn color="primary" round class="white--text" @click="saveNewContact">Save</v-btn>
            <!-- </v-layout> -->
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="editContactModal" max-width="750px">
        <v-card>
          <v-toolbar flat class="primary">
            <h1 class="headline white--text">EDIT CONTACT</h1>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <h3 dark-grey--text>Personal Details</h3>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.name"
                    label="*First Name"
                    persistent-hint
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.surname"
                    label="*Surname"
                    persistent-hint
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.idNumber"
                    label="*RSA ID Number or Passport Number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    v-model="editedItem.contactTypeId"
                    :items="contactTypes"
                    item-text="name"
                    item-value="id"
                    label="*Contact Type"
                    persistent-hint
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <h3 dark-grey--text>Contact Details</h3>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.mobileNumber"
                    label="*Mobile Number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.telephoneNumber"
                    label="Telephone Number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <h3 dark-grey--text>Login Settings</h3>
                </v-flex>

                <v-flex xs12 sm3 md6>
                  <v-text-field
                    v-model="editedItem.emailAddress"
                    prepend-icon="email"
                    label="*Email Address"
                    persistent-hint
                    type="email"
                    v-on:blur="checkEmail"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="editedItem.password"
                    prepend-icon="security"
                    label="Reset Password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-btn flat color="primary" @click="resetPassword">Reset</v-btn>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center layout px-0">
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="saveContact(editedItem); close">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Add new item modal -->
      <v-dialog persistent v-model="newDialog" max-width="750px">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ADD DEVICE</h1>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-tabs>
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab
              @click="devicetab=true;additionalInformation=false; commenttab=false"
              class="grey--text"
              flat
              round
              color="grey"
            >Basic Information</v-tab>
            <!-- <v-tab
              @click="devicetab=false;additionalInformation=true; commenttab=false"
              class="grey--text"
              flat
              round
              color="grey"
            >Additional Information</v-tab> -->
          </v-tabs>
        </v-toolbar>
        <v-card flat>
          <v-card flat v-show="devicetab">
            <v-card-text>
              <v-container grid-list-xs>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.systemName" label="System Name" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.ipAddress" label="IP Address" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.serialNumber" label="Serial Number" required></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.ponMac" label="Pon Mac"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.macAddress" label="Mac Address"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.ponNumerical" label="Pon Numerical"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.productNumber" label="Product Number"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-autocomplete
                      clearable
                      v-model="editedItem.deviceMakeModelId"
                      :items="deviceMakeModel"
                      hide-no-data
                      flat
                      color="primary"
                      label="*Device Make Model"
                      item-text="name"
                      item-value="id"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>

          <v-card flat v-show="additionalInformation">
            <v-card-text>
              <v-container grid-list-xs>
                <v-layout wrap>
                  <v-flex v-show="addButton" xs12 sm6 md6>
                    <v-btn
                      v-if=" this.selectedDevice.lenth==0 ||this.editedItem.upstreamDeviceId == null || typeof(this.editedItem.upstreamDeviceId) == 'undefined' || typeof(this.selectedDevice[0]) == 'undefined'"
                      color="primary"
                      flat
                      @click="deviceSearch=true; selectedDevice=[]; addButton=false"
                    >Add Upstream Device</v-btn>
                  </v-flex>

                  <v-flex v-if="this.selectedDevice[0]" xs12 sm6 md6>
                    <v-text-field
                      v-model="selectedDevice[0].deviceMakeModel.name"
                      label="Upstream Device Make Model Name"
                      readonly
                      persistent-hint
                    ></v-text-field>
                    <v-btn
                      v-if="this.selectedDevice.length>0"
                      flat
                      color="primary"
                      @click="deviceSearch=true"
                    >Edit Upstream Device</v-btn>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.frame" label="Frame" type="number"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.slot" label="Slot" type="number"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.port" label="Port" type="number"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.ponId" label="PON ID" type="number"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.note" label="Note"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
          <v-card-actions>
            <v-layout row justify-center align-center>
              <v-btn color="primary" round class="white--text" @click="close">Cancel</v-btn>
            <v-btn color="primary" round class="white--text" @click="saveNewDevice">Save</v-btn>
            </v-layout>
            
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Edit Modal -->
      <v-dialog persistent v-model="dialog" max-width="750px">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">EDIT DEVICE</h1>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-tabs>
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab
              @click="devicetab=true;additionalInformation=false; commenttab=false"
              class="grey--text"
              flat
              round
              color="grey"
            >Basic Information</v-tab>
            <v-tab
              @click="devicetab=false;additionalInformation=true; commenttab=false"
              class="grey--text"
              flat
              round
              color="grey"
            >Additional Information</v-tab>
            <v-tab
              @click="devicetab=false;additionalInformation=false; commenttab=true"
              class="grey--text"
              flat
              round
              color="grey"
            >Comments</v-tab>
          </v-tabs>
        </v-toolbar>
        <v-card flat>
          <v-card flat v-show="devicetab">
            <v-card-text>
              <v-container grid-list-xs>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.systemName" label="System Name" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.ipAddress" label="IP Address" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.serialNumber" label="Serial Number" required></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.ponMac" label="Pon Mac"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.macAddress" label="Mac Address"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.ponNumerical" label="Pon Numerical"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.productNumber" label="Product Number"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-autocomplete
                      clearable
                      v-model="editedItem.deviceMakeModelId"
                      :items="deviceMakeModel"
                      hide-no-data
                      flat
                      color="primary"
                      label="*Device Make Model"
                      item-text="name"
                      item-value="id"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
          <v-card flat v-show="additionalInformation">
            <v-card-text>
              <v-container grid-list-xs>
                <v-layout wrap>
                  <v-flex v-if="this.addButton==true" xs12 sm6 md6>
                    <v-btn
                      color="primary"
                      flat
                      @click="deviceSearch=true; selectedDevice=[]; addButtonFunc()"
                    >Add Upstream Device</v-btn>
                  </v-flex>
                  <v-flex
                    v-if="this.selectedDevice.length>0|| typeof(this.selectedDevice[0]) != 'undefined' || this.selectedDevice[0] !=null"
                    xs12
                    sm6
                    md6
                  >
                    <v-text-field
                      v-model="selectedDevice[0].deviceMakeModel.name"
                      label="Upstream Device Make Model Name"
                      readonly
                      persistent-hint
                    ></v-text-field>
                    <v-btn flat color="primary" @click="deviceSearch=true">Edit Upstream Device</v-btn>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.frame" label="Frame" type="number"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.slot" label="Slot" type="number"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.port" label="Port" type="number"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.ponId" label="PON ID" type="number"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.note" label="Note"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>

          <v-card flat v-show="commenttab">
            <v-card-text>
              <v-toolbar flat class="white">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  @click="clearComments(); addCommentDialog=true"
                  round
                >ADD COMMENT</v-btn>
              </v-toolbar>
              <v-data-table
                :loading="loading"
                :headers="commentHeaders"
                :items="deviceComments"
                item-key="id"
              >
                <template v-slot:items="props">
                  <td class="justify-center layout px-0">
                    <v-icon small @click=" editComment(props.item)">edit</v-icon>
                    <v-icon small @click="deleteComment(props.item.id)">delete</v-icon>
                  </td>
                  <td class="text-xs-center">{{formatDate(props.item.dateTimeStamp)}}</td>
                  <td
                    class="text-xs-center"
                  >{{props.item.contact.name + ' ' + props.item.contact.surname}}</td>
                  <td class="text-xs-center">{{props.item.comments}}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

          <v-card-actions>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="saveDevice">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      <v-dialog persistent v-model="addCommentDialog" max-width="750px">
        <v-card>
          <v-toolbar flat class="primary">
            <h1 class="headline white--text">ADD COMMENT</h1>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12>
                  <v-textarea v-model="editedCommentItem.comments" label="Comments" persistent-hint></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" flat @click="addCommentDialog=false">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="addComment()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      <v-dialog persistent v-model="editCommentDialog" max-width="750px">
        <v-card>
          <v-toolbar flat class="primary">
            <h1 class="headline white--text">EDIT COMMENT</h1>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12>
                  <v-textarea v-model="editedCommentItem.comments" label="Comments" persistent-hint></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" flat @click="editCommentDialog=false">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="saveComment()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

      <!-- Add Service Account item modal /////////////////////////////////////////////////////////////////////////////////-->
      <v-dialog persistent v-model="addServiceAccountModal" max-width="750px">
        <v-card>
          <v-toolbar flat class="primary">
            <h1 class="headline white--text">ADD SERVICE ACCOUNT</h1>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="customers"
                    item-text="name"
                    item-value="id"
                    v-model="customerId"
                    label=" Customer*"
                    required
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6></v-flex>

                <v-flex xs12 sm6 md4 v-show="customerId&&editedItem.vlanId===null">
                  <v-btn @click="addVlanModal=true" flat>
                    <v-icon justify-center layout small>add</v-icon>Add Vlan
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 md8 v-show="customerId&&editedItem.vlanId===null"></v-flex>
                <v-flex xs12 sm6 md4 v-show="customerId&&editedItem.vlanId">
                  <v-btn @click="addVlanModal=true" flat>
                    <v-icon justify-center layout small>edit</v-icon>Edit Vlan
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 md8 v-show="customerId&&editedItem.vlanId">
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    v-model="editedItem.vlanId"
                    :items="vlans"
                    item-text="serviceVlan"
                    item-value="id"
                    disabled
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md4 v-show="customerId&&!editedItem.locationId">
                  <v-btn @click="locationSearch=true" flat>
                    <v-icon justify-center layout small>add</v-icon>Add Location
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 md8 v-show="customerId&&!editedItem.locationId"></v-flex>
                <v-flex xs12 sm6 md4 v-show="customerId&&editedItem.locationId">
                  <v-btn @click="locationSearch=true" flat>
                    <v-icon justify-center layout small>edit</v-icon>Edit Location
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 md8 v-show="customerId&&editedItem.locationId">
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    v-model="editedItem.locationId"
                    :items="selectedLocation"
                    item-text="locationDescription"
                    item-value="id"
                    disabled
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <h4
                    v-show="customerId&&editedItem.locationId&&existingServiceAccounts.length>0"
                  >Service Account History</h4>
                  <v-data-table
                    v-show="customerId&&editedItem.locationId&&existingServiceAccounts.length>0"
                    :headers="existingServiceAccountsHeaders"
                    class="elevation-1"
                    :search="search"
                    :expand="expand"
                    :pagination.sync="pagination"
                    :loading="isloading"
                    :items="existingServiceAccounts"
                    :rows-per-page-items="[3,5,10]"
                    item-key="id"
                    align-center
                  >
                    <template v-slot:items="props">
                      <td class="justify-center layout px-0">
                        <v-icon
                          v-if="((props.item.authenticationType==='PPPoE'&&props.item.pppoeUsername!==null&&props.item.pppoePassword!==null)||
        (props.item.authenticationType==='IPoE'&&props.item.IPoEMacAddress!==null))
        &&(props.item.fnoActivationDate!==null&&new Date(props.item.fnoActivationDate)<new Date())&&(props.item.fnoDeactivationDate===null||new Date(props.item.fnoDeactivationDate)>new Date())
          &&(props.item.ispActivationDate!==null&&new Date(props.item.ispActivationDate)<new Date())&&(props.item.ispDeactivationDate===null||new Date(props.item.ispDeactivationDate)>new Date())
        &&(props.item.deviceId!==null)&&(props.item.isActive===true)"
                          small
                          class="mr-2"
                          color="blue"
                          @click="logChangeRequest(props.item)"
                        >schedule</v-icon>
                        <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                        <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
                      </td>

                      <td class="text-xs-center">
                        <v-chip
                          small
                          dark
                          color="success"
                          v-if="((props.item.authenticationType==='PPPoE'&&props.item.pppoeUsername!==null&&props.item.pppoePassword!==null)||
        (props.item.authenticationType==='IPoE'&&props.item.IPoEMacAddress!==null))
        &&(props.item.fnoActivationDate!==null&&new Date(props.item.fnoActivationDate)<new Date())&&(props.item.fnoDeactivationDate===null||new Date(props.item.fnoDeactivationDate)>new Date())
          &&(props.item.ispActivationDate!==null&&new Date(props.item.ispActivationDate)<new Date())&&(props.item.ispDeactivationDate===null||new Date(props.item.ispDeactivationDate)>new Date())
        &&(props.item.deviceId!==null)&&(props.item.isActive===true)"
                        >Active</v-chip>
                        <v-chip
                          small
                          dark
                          color="blue"
                          v-else-if="(props.item.authenticationType==='PPPoE'&&(props.item.pppoeUsername===null||props.item.pppoePassword===null))
        ||((props.item.fnoActivationDate!==null&&new Date(props.item.fnoActivationDate)<new Date())
        &&(props.item.ispActivationDate===null||(props.item.ispActivationDate!==null&&new Date(props.item.ispActivationDate)>new Date())))
        &&(props.item.deviceId!==null)&&(props.item.isActive===true)"
                        >ISP Action</v-chip>
                        <v-chip
                          small
                          dark
                          color="warning"
                          v-else-if="(props.item.authenticationType==='IPoE'&&props.item.IPoEMacAddress===null)
        ||((props.item.fnoActivationDate===null))
        ||(props.item.deviceId===null)"
                        >FNO Action</v-chip>
                        <v-chip small dark color="red" v-else>Inactive</v-chip>
                        <!-- <v-chip small dark color="success">Active</v-chip> -->
                      </td>
                      <td class="text-xs-center">{{props.item.packagesIsp.customer.name}}</td>
                      <td class="text-xs-center">{{props.item.packagesIsp.name}}</td>
                    </template>
                    <template
                      v-slot:pageText="props"
                    >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 sm6 md4 v-show="customerId">
                  <v-btn @click="deviceSearch=true" flat>
                    <v-icon justify-center layout small>add</v-icon>Add Unused Device
                  </v-btn>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                  v-show="customerId&&locationDevices.length>0&&!editedItem.deviceId"
                >
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    v-model="editedItem.deviceId"
                    :items="locationDevices"
                    item-text="deviceMakeModel.name"
                    item-value="id"
                    label="Devices at Location"
                  ></v-autocomplete>
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  md8
                  v-show="customerId&&!editedItem.deviceId&&locationDevices.length===0"
                ></v-flex>
                <!-- <v-flex xs12 sm6 md4 v-show="customerId&&editedItem.deviceId">
                <v-btn @click="deviceSearch=true" flat>
                  <v-icon justify-center layout small>edit</v-icon>Edit Device
                </v-btn>
                </v-flex>-->
                <!-- <v-flex xs12 sm6 md4 v-show="customerId&&editedItem.deviceId&&locationDevices.length>0">
                <v-btn @click="deviceSearch=true" flat>
                  <v-icon justify-center layout small>edit</v-icon>Attach Unused Device
                </v-btn>
                </v-flex>-->
                <v-flex
                  xs12
                  sm6
                  md8
                  v-show="customerId&&editedItem.deviceId&&locationDevices.length===0"
                >
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    v-model="editedItem.deviceId"
                    :items="selectedDevice"
                    item-text="deviceMakeModel.name"
                    item-value="id"
                    label="Selected Device"
                    persistent-hint
                  ></v-autocomplete>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md8
                  v-show="customerId&&editedItem.deviceId&&locationDevices.length>0"
                >
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    v-model="editedItem.deviceId"
                    :items="locationDevices"
                    item-text="deviceMakeModel.name"
                    item-value="id"
                    label="Devices at Location"
                    persistent-hint
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6 v-show="customerId&&editedItem.locationId">
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="packagesIsp"
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.packagesIspId"
                    label="*ISP package"
                    required
                  ></v-autocomplete>
                </v-flex>

                <!-- <v-flex  xs12 sm6 md4> <v-text-field v-model="editedItem.authenticationType" label=" authenticationType*" required></v-text-field> </v-flex> -->
                <v-flex xs12 sm6 md6 v-show="customerId&&editedItem.locationId">
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    label="*Authentication Type"
                    :items="authenticationType"
                    v-model="editedItem.authenticationType"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6 v-if="editedItem.authenticationType==='PPPoE'">
                  <v-text-field v-model="editedItem.pppoeUsername" label=" PPPoE Username"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 v-if="editedItem.authenticationType==='PPPoE'">
                  <v-text-field v-model="editedItem.pppoePassword" label=" PPPoE Password"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 v-if="editedItem.authenticationType==='IPoE'">
                  <v-text-field v-model="editedItem.IPoEMacAddress" label="IPoE MAC Address"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 v-if="editedItem.authenticationType==='IPoE'"></v-flex>
                <v-flex xs12 sm6 md6 v-show="editedItem.packagesIspId">
                  <v-menu>
                    <v-text-field
                      :value="this.editedItem.fnoActivationDate"
                      slot="activator"
                      label="FNO Activation Date"
                      prepend-icon="date_range"
                      required
                    ></v-text-field>
                    <v-date-picker v-model="editedItem.fnoActivationDate"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md6 v-show="editedItem.packagesIspId">
                  <v-menu>
                    <v-text-field
                      :value="this.editedItem.fnoDeactivationDate"
                      slot="activator"
                      label="FNO Deactivation Date"
                      prepend-icon="date_range"
                      required
                    ></v-text-field>
                    <v-date-picker v-model="editedItem.fnoDeactivationDate"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md6 v-show="editedItem.authenticationType">
                  <v-menu>
                    <v-text-field
                      :value="this.editedItem.ispActivationDate"
                      slot="activator"
                      label="ISP Activation Date"
                      prepend-icon="date_range"
                      required
                    ></v-text-field>
                    <v-date-picker v-model="editedItem.ispActivationDate"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md6 v-show="editedItem.authenticationType">
                  <v-menu>
                    <v-text-field
                      :value="this.editedItem.ispDeactivationDate"
                      slot="activator"
                      label="ISP Deactivation Date"
                      prepend-icon="date_range"
                      required
                    ></v-text-field>
                    <v-date-picker v-model="editedItem.ispDeactivationDate"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md6 v-show="editedItem.authenticationType">
                  <v-text-field v-model="editedItem.staticIpv4" label="Static Ipv4"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 v-show="editedItem.authenticationType">
                  <v-text-field v-model="editedItem.staticIpv6" label="Static Ipv6"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions class="justify-center layout px-0">
            <v-btn color="primary" round @click="close">Cancel</v-btn>
            <v-btn color="primary" round @click="saveNewServiceAccount">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card>
        <div v-if="displayContents('summary')">
          <v-container grid-list-xs>
            <v-layout wrap>
              <!-- <v-flex xs12 sm6 md6 lg6>
                <h3 class="pt-3">
                  Service Accounts
                  <v-btn flat color="primary" @click="addServiceAccountModal=true">
                    <v-icon>add</v-icon>
                  </v-btn>
                </h3>
                <v-container>
                  <v-layout row wrap>
                   <v-data-table
                   v-if="serviceAccounts.length>0"
      :headers="serviceAccountHeaders"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="serviceAccounts"
      :rows-per-page-items="[25, 50, 100, 250]"
      item-key="name"
      align-center
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
        </td>
        <td class="text-xs-center">
                      <v-chip
                        small
                        dark
                        color="success"
                        v-if="((props.item.authenticationType==='PPPoE'&&props.item.pppoeUsername!==null&&props.item.pppoePassword!==null)||
        (props.item.authenticationType==='IPoE'&&props.item.IPoEMacAddress!==null))
        &&(props.item.fnoActivationDate!==null&&new Date(props.item.fnoActivationDate)<new Date())&&(props.item.fnoDeactivationDate===null||new Date(props.item.fnoDeactivationDate)>new Date())
          &&(props.item.ispActivationDate!==null&&new Date(props.item.ispActivationDate)<new Date())&&(props.item.ispDeactivationDate===null||new Date(props.item.ispDeactivationDate)>new Date())
        &&(props.item.deviceId!==null)&&(props.item.isActive===true)"
                      >Active</v-chip>
                      <v-chip
                        small
                        dark
                        color="blue"
                        v-else-if="(props.item.authenticationType==='PPPoE'&&(props.item.pppoeUsername===null||props.item.pppoePassword===null))
        ||((props.item.fnoActivationDate!==null&&new Date(props.item.fnoActivationDate)<new Date())
        &&(props.item.ispActivationDate===null||(props.item.ispActivationDate!==null&&new Date(props.item.ispActivationDate)>new Date())))
        &&(props.item.deviceId!==null)&&(props.item.isActive===true)"
                      >ISP Action</v-chip>
                      <v-chip
                        small
                        dark
                        color="warning"
                        v-else-if="(props.item.authenticationType==='IPoE'&&props.item.IPoEMacAddress===null)
        ||((props.item.fnoActivationDate===null))
        ||(props.item.deviceId===null)"
                      >FNO Action</v-chip>
                      <v-chip
                        small
                        dark
                        color="red"
                        v-else
                      >Inactive</v-chip>
                    </td>
        <td class="text-xs-center">{{props.item.packagesIsp.customer.name}}</td>
        <td class="text-xs-center">{{props.item.vlan.serviceVlan}}</td>
        <td class="text-xs-center">{{props.item.packagesIsp.name}}</td>
        <td class="text-xs-center">{{props.item.packagesIsp.packagesFno.packageCode}}</td>
        <td class="text-xs-center">{{props.item.authenticationType}}</td>
        <td class="text-xs-center">{{props.item.pppoeUsername}}</td>
        <td class="text-xs-center">{{props.item.pppoePassword}}</td>
        <td class="text-xs-center">{{props.item.IPoEMacAddress}}</td>
        <td class="text-xs-center">{{formatDate(props.item.fnoActivationDate)}}</td>
        <td class="text-xs-center">{{formatDate(props.item.fnoDeactivationDate)}}</td>
        <td class="text-xs-center">{{formatDate(props.item.ispActivationDate)}}</td>
        <td class="text-xs-center">{{formatDate(props.item.ispDeactivationDate)}}</td>
        <td class="text-xs-center">{{props.item.staticIpv4}}</td>
        <td class="text-xs-center">{{props.item.staticIpv6}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
                  </v-layout>
                </v-container>
              </v-flex>-->

              <v-flex xs12 sm6 md6 lg6>
                <h3 class="pt-3">
                  Contacts
                  <v-btn flat color="primary" @click="addContactModal=true;fetchAllContacts()">
                    <v-icon>add</v-icon>
                  </v-btn>
                </h3>
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md6 lg6 v-for="person in Contacts" :key="person.contact.name">
                      <v-card hover class="text-xs-center mb-2 mx-2">
                        <div
                          class="primary subheading text-uppercase white--text"
                        >{{person.contactType.name}}</div>
                        <v-responsive></v-responsive>
                        <v-card-text>
                          <div class="subheading">{{person.contact.name}} {{person.contact.surname}}</div>
                          <div class="grey--text">M: {{person.contact.mobileNumber}}</div>
                          <div class="grey--text">T: {{person.contact.telephoneNumber}}</div>
                          <div
                            class="grey--text"
                            prepend-icon="email"
                          >{{person.contact.emailAddress}}</div>
                        </v-card-text>
                        <v-card-actions class="justify-center layout px-0">
                          <v-btn flat color="primary" @click="editContact(person)">
                            <v-icon small>edit</v-icon>Edit
                          </v-btn>
                          <v-btn flat color="red" @click="removeContact(person)">
                            <v-icon small>delete</v-icon>Remove
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>

              <v-flex xs12 sm6 md6 lg6>
                <h3 class="pt-3 pb-3">Devices</h3>
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md6 lg6 v-for="device in devices" :key="device.id">
                      <v-card hover class="text-xs-center mb-2 mx-2 mt-2">
                        <div
                          class="primary subheading text-uppercase white--text"
                        >{{device.deviceMakeModel.deviceType.name}}</div>
                        <v-responsive></v-responsive>
                        <v-card-text>
                          <div class="grey--text">Make: {{device.deviceMakeModel.name}}</div>
                          <div class="grey--text">PON MAC: {{device.ponMac}}</div>
                          <div class="grey--text">Serial Number: {{device.serialNumber}}</div>
                          <div
                            class="grey--text"
                          >FSP: {{device.frame}}/{{device.slot}}/{{device.port}}</div>
                          <div class="grey--text">PON ID: {{device.ponId}}</div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <div v-if="displayContents('showApplications')">
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field label="Search" v-model="searchApplications"></v-text-field>
          </v-toolbar>
          <v-data-table
      :headers="applicationHeaders"
      class="elevation-1"
      :pagination.sync="installPagination"
      :rows-per-page-items="[25, 50, 100, 250]"
      :loading="loading"
      :items="applications"
      :search="searchApplications"
      item-key="id"
      disable-initial-sort
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <!-- <td class="justify-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="props.item.packagesIspId!==null&&props.item.serviceAccountId===null"
                medium
                @click="createServiceAccount(props.item)"
                color="primary"
              >add_circle</v-icon>
            </template>
            <span>Create Service Account</span>
          </v-tooltip>
        </td> -->
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
          <span v-if="props.item.isResolved">
            <v-chip v-if="props.item.isApproved" class="green white--text">Approved</v-chip>
            <v-chip v-else class="red white--text">Denied</v-chip>
          </span>
          <v-chip color="blue" class="white--text" v-else>Pending</v-chip>
        </td>
        
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{formatDate(props.item.createdAt)}}</td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.id}}</td>
        <td class="text-xs-center" v-if="props.item.primaryContactTitle!==null" @click="routerLinkToDetails(props.item)">{{props.item.primaryContactTitle + ' '+props.item.primaryContactFirstname+ ' '+props.item.primaryContactLastname}}</td>
        <td class="text-xs-center" v-else @click="routerLinkToDetails(props.item)">{{props.item.primaryContactFirstname+ ' '+props.item.primaryContactLastname}}</td>
        
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.primaryContactMobileNumber}}</td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.primaryContactEmailAddress}}</td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.comment}}</td>

        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.packagesIspId !== null">{{props.item.packagesIsp.customerOrganisation.name}}</td>
        <td v-else></td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.packagesIspId !== null">{{props.item.packagesIsp.name}}</td>
        <td v-else></td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.serviceAccountId}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
        </div>

        <div v-if="displayContents('deviceContents')">
          <v-toolbar flat color="white" class="pt-3">
            <v-btn
              round
              class="primary"
              @click="fetchUnusedDevices()"
            >Attach Device</v-btn>
            <v-btn
              round
              class="primary"
              @click="fetchDeviceMakeModels();newDialog=true; devicetab=true; ;additionalInformation=false; commenttab=false; addButton=true; cancelFields()"
            >Add New Device</v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              max-width="50px"
              class="pa-3"
              clearable
            ></v-text-field>
          </v-toolbar>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-data-table
              :items="devices"
              :headers="deviceHeaders"
              class="elevation-1"
              :expand="expand"
              :search="search"
              :rows-per-page-items="[25, 50, 100]"
              item-key="id"
              align-center
              style="cursor: pointer"
            >
              <template v-slot:items="props">
                <td class="justify-center align-center layout px-0">
                  <!-- <v-icon
                    small
                    class="mr-2"
                    @click="editItem(props.item); dialog=true; ; devicetab=true;additionalInformation=false; commenttab=false"
                  >edit</v-icon> -->
                  <v-icon small @click="deleteDevice(props.item.id)">delete</v-icon>
                </td>
                <td class="text-xs-center">{{props.item.systemName}}</td>

                <td
                  v-if="props.item.locationId != null && props.item.location"
                  class="text-xs-center"
                  @click="viewDeviceDetails(props.item)"
                >{{props.item.location.locationDescription}}</td>
                <td
                @click="viewDeviceDetails(props.item)"
                  v-else-if="props.item.locationNetworkId != null && props.item.locationNetwork"
                  class="text-xs-center"
                >{{props.item.locationNetwork.name}}</td>
                <td
                @click="viewDeviceDetails(props.item)"
                  v-else-if="props.item.locationNodeId != null && props.item.locationNode"
                  class="text-xs-center"
                >{{props.item.locationNode.name}}</td>
                <td
                @click="viewDeviceDetails(props.item)"
                  v-else-if="props.item.switchingCentreId != null && props.item.switchingCentre"
                  class="text-xs-center"
                >{{props.item.switchingCentre.name}}</td>
                <td @click="viewDeviceDetails(props.item)" v-else class="text-xs-center"></td>
                <!-- <td class="text-xs-center" v-else></td> -->
                <td
                @click="viewDeviceDetails(props.item)"
                  class="text-xs-center"
                  v-if="props.item.deviceMakeModelId!==null"
                >{{props.item.deviceMakeModel.deviceMake.name}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center" v-else></td>
                <td
                @click="viewDeviceDetails(props.item)"
                  class="text-xs-center"
                  v-if="props.item.deviceMakeModelId!==null"
                >{{props.item.deviceMakeModel.deviceType.name}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center" v-else></td>
                <td
                @click="viewDeviceDetails(props.item)"
                  class="text-xs-center"
                  v-if="props.item.deviceMakeModelId!==null"
                >{{props.item.deviceMakeModel.name}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center" v-else></td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ipAddress}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.serialNumber}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ponMac}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.macAddress}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ponNumerical}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.productNumber}}</td>
                <td
                @click="viewDeviceDetails(props.item)"
                  class="text-xs-center"
                  v-if="props.item.upstreamDeviceId!=null && props.item.upstreamDevice"
                >{{props.item.upstreamDevice.deviceMakeModel.name}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center" v-else></td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ponAddress}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ponId}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.frame}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.slot}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.port}}</td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.note}}</td>

                <td @click="viewDeviceDetails(props.item)" class="text-xs-center" v-if="props.item.isActive">
                  <v-icon color="green">done</v-icon>
                </td>
                <td @click="viewDeviceDetails(props.item)" class="text-xs-center" v-else>
                  <v-icon color="red">not_interested</v-icon>
                </td>
              </template>
              <!-- Custom Row count and Paging text -->
              <template
                v-slot:pageText="props"
              >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
              <!-- No data Dispalay -->
              <!-- <template v-slot:no-data>
                  <v-alert
                    :value="true"
                    color="error"
                    icon="warning"
                  >Sorry, nothing to display here :(</v-alert>
              </template>-->
            </v-data-table>
          </v-flex>
          <!-- <deviceCard
                  :devices="devices">
          </deviceCard>-->
        </div>

        <div v-if="displayContents('showInstallations')">
          <!-- FUll Installation Modal -->
          <v-dialog persistent v-model="addInstallationModal" max-width="1200px">
            <v-card v-if="installation!==null">
              <v-toolbar flat class="primary">
                <h1 class="headline white--text">VIEW INSTALLATION</h1>
                <v-spacer></v-spacer>
                 <v-btn
                  color="white"
                  flat
                  large
                  @click="setActiveInstallTabName('installSummary'),addInstallationModal=false; installation={}"
                >X</v-btn>
              </v-toolbar>
               <v-toolbar flat color="white">
                <v-tabs  div="tabs">
                  <v-tabs-slider color="primary"></v-tabs-slider>
                  <v-tab
                    href="#"
                    v-for="tab in installTabs"
                    :key="tab.name"
                    @click="setActiveInstallTabName(tab.name)"
                  >
                  <span>{{tab.displayName}}</span>
                  <!-- <span v-if="installation.installType==='Active'||installation.installType==='ActivePassive'&&tab.name=='installSummary'||tab.name==='activeInstall'">{{tab.displayName}}</span>
                  <span v-else-if="installation.installType==='Passive'||installation.installType==='ActivePassive'&&tab.name=='installSummary'||tab.name==='passiveInstall'">{{tab.displayName}}</span></v-tab> -->
                  </v-tab>
                </v-tabs>
              </v-toolbar>
              <v-card-text>
                <v-container xs12 grid-list-md>
                  <v-layout wrap col v-if="displayInstallContents('installSummary')">
                      <v-flex xs12>
                      <h3>Install Information</h3>
                    </v-flex>
                        <v-flex xs3><h3 class="grey--text">Install Date:</h3></v-flex>
                        <v-flex xs3><h3 class="font-weight-light grey--text">{{formatDate(installation.createdAt)}}</h3></v-flex>
                        <v-flex xs3><h3 class="grey--text">Installed By:</h3></v-flex>
                        <v-flex xs3><h3 class="font-weight-light grey--text" v-if="installation.installedBy !=='undefined' && installation.installedById!==null">{{installation.installedBy.name}} {{installation.installedBy.surname}}</h3>
                        <h3 class="font-weight-light grey--text" v-else>No Details</h3></v-flex>
                        <v-flex xs3><h3 class="grey--text">Install Type:</h3></v-flex>
                        <v-flex xs3><h3 class="font-weight-light grey--text" v-if="installation.installType==='ActivePassive'">Active & Passive</h3>
                        <h3 class="font-weight-light grey--text" v-else>{{installation.installType}}</h3></v-flex>

                      <v-flex mt-3 xs12 v-if="installation.signOffName!==null">
                      <h3>Customer Sign-Off</h3>
                    </v-flex>
                        <v-flex xs3><h3 class="grey--text">Signed Off By:</h3></v-flex>
                        <v-flex xs3><h3 class="font-weight-light grey--text">{{installation.signOffName}} {{installation.signOffSurname}}</h3></v-flex>
                        <v-flex xs3><h3 class="grey--text">Contact No:</h3></v-flex>
                        <v-flex xs3><h3 class="font-weight-light grey--text">{{installation.signOffMobileNo}}</h3></v-flex>
                        <v-flex xs3><h3 class="grey--text">Signature:</h3></v-flex>
                        <v-flex xs3><v-img max-width="50%" max-height="50%" :src="installation.signOffSignature"></v-img></v-flex>
                     <v-flex mt-3 xs12 v-if="installation.connectionName||installation.connectionPassword">
                      <h3>SSID</h3>
                    </v-flex>
                    <v-flex xs3  v-if="installation.connectionName||installation.connectionPassword"
                      ><h3 class="grey--text">Name:</h3></v-flex
                    >
                    <v-flex xs3 v-if="installation.connectionName"
                      ><h3 class="font-weight-light grey--text">
                        {{ installation.connectionName }}
                      </h3></v-flex
                    >
                    <v-flex xs3  v-if="installation.connectionName||installation.connectionPassword"
                    ><h3 class="grey--text">Password:</h3></v-flex>
                    <v-flex xs3 v-if="installation.connectionPassword"
                      ><h3 class="font-weight-light grey--text">
                        {{ installation.connectionPassword }}
                      </h3></v-flex
                    >
                    </v-layout>

                  <v-layout wrap col v-if="displayInstallContents('passiveInstall')">
                      <!-- <v-flex xs12 sm12 md12 lg12 v-if="installation.isPassiveInstall||installation.installType==='Passive'||installation.installType==='ActivePassive'">
                      <h3>Passive Installation</h3>
                    </v-flex> -->
                    <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall">
                      <v-switch disabled v-model="installation.patchLead" label="Patchlead"></v-switch>
                    </v-flex>
                    <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall">
                      <v-switch disabled v-model="installation.ftthBox" label="FTTH Box"></v-switch>
                    </v-flex>
                    <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall">
                      <v-switch disabled v-model="installation.labelling" label="Labelling"></v-switch>
                    </v-flex>
                    <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall">
                      <v-switch disabled v-model="installation.mstConnection" label="MST Connection"></v-switch>
                    </v-flex>
                    <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall||installation.installType==='Passive'||installation.installType==='ActivePassive'">
                      <v-text-field
                      disabled
                        v-model="installation.passiveDataReading"
                        label="Passive Data Reading"
                        persistent-hint
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall||installation.installType==='Passive'||installation.installType==='ActivePassive'">
                      <v-text-field
                      disabled
                        v-model="installation.passiveVideoReading"
                        label="Passive Video Reading"
                        persistent-hint
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-layout justify-center>
                      <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall||installation.installType==='Passive'||installation.installType==='ActivePassive'&&installation.passiveInstallPhoto!==null">
                      <v-layout justify-center v-if="installation.passiveInstallPhoto!==null">
                        <v-flex xs12>
                        <v-flex xs12>
                          <v-img :src="installation.passiveInstallPhoto"></v-img>
                          <a download="passiveInstallPhoto.jpg" :href="installation.passiveInstallPhoto">Download</a>
                        </v-flex>
                        <v-flex xs12><h3>Complete Passive Install</h3></v-flex>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                     <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall||installation.installType==='Passive'||installation.installType==='ActivePassive'&&installation.labellingPhoto!==null">
                      <v-layout justify-center v-if="installation.labellingPhoto!==null">
                        <v-flex xs12>
                        <v-flex xs12>
                          <v-img :src="installation.labellingPhoto"></v-img>
                          <a download="mstLabellingPhoto.jpg" :href="installation.labellingPhoto">Download</a>
                        </v-flex>
                        <v-flex xs12><h3>MST Labelling</h3></v-flex>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    </v-layout>
                    </v-flex>
                    </v-layout>
                    
                </v-container>
                <v-layout  v-if="displayInstallContents('activeInstall')" wrap col justify-center>
                    <!-- <v-flex xs12 sm12 md12 lg12 v-if="installation.isActiveInstall||installation.installType==='Active'||installation.installType==='ActivePassive'">
                      <h3>Active Installation</h3>
                    </v-flex> -->
                    <v-flex xs3 v-if="installation.isActiveInstall||installation.installType==='Active'||installation.installType==='ActivePassive'">
                      <v-text-field
                      disabled
                        v-model="installation.activeDataReading"
                        label="Active Data Reading"
                        persistent-hint
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 v-if="installation.isActiveInstall||installation.installType==='Active'||installation.installType==='ActivePassive'">
                      <v-text-field
                      disabled
                        v-model="installation.activeVideoReading"
                        label="Active Video Reading"
                        persistent-hint
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-layout justify-center v-if="installation.ponmacPhoto!==null">
                      <v-flex xs6>
                      <v-layout justify-center >
                        <v-flex xs12>
                        <v-flex xs12>
                          <v-img max-height="150px" :src="installation.ponmacPhoto"></v-img>
                          <a download="ponmacPhoto.jpg" :href="installation.ponmacPhoto">Download</a>
                        </v-flex>
                        <v-flex xs12><h3>PON MAC Photo</h3></v-flex>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="installation.activeInstallPhoto!==null">
                      <v-flex xs6>
                      <v-layout justify-center>
                        <v-flex xs12>
                        <v-flex xs12>
                          <v-img max-height="150px" :src="installation.activeInstallPhoto"></v-img>
                          <a download="activeInstallPhoto.jpg" :href="installation.activeInstallPhoto">Download</a>
                        </v-flex>
                        <v-flex xs12><h3>Complete Active Install</h3></v-flex>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-if="installation.installationDevices!=='undefined' && installation.installationDevices.length>0"><h3>Installed Devices</h3></v-flex>
                    <v-layout justify-center align-center v-if="installation.installationDevices!=='undefined'">
                      <v-flex xs4 v-for="device in installation.installationDevices" :key="device.deviceId">
                        <v-card hover class="text-xs-center mb-2 mx-2 mt-2" @click="routeDevice(device.device)">
                        <div
                          class="primary subheading text-uppercase white--text"
                        >{{device.device.deviceMakeModel.deviceMake.name}} {{device.device.deviceMakeModel.name}}</div>
                        <v-responsive></v-responsive>
                        <v-card-text>
                          <!-- <div class="grey--text">Make: {{device.device.deviceMakeModel.name}}</div> -->
                          <div class="grey--text">PON MAC: {{device.device.ponMac}}</div>
                          <div class="grey--text">Serial Number: {{device.device.serialNumber}}</div>
                          <!-- <div
                            class="grey--text"
                          >FSP: {{device.frame}}/{{device.slot}}/{{device.port}}</div>
                          <div class="grey--text">PON ID: {{device.ponId}}</div> -->
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    </v-layout>
                  </v-layout>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-flex xs12 sm12 md12 lg12></v-flex>
          <v-flex xs12 sm12 md12 lg12>
            <!-- <v-btn
              xs4
              sm4
              md4
              lg4
              round
              class="primary"
              @click="addInstallationModal=true; installation.isActiveInstall=true;installation.isPassiveInstall=true"
            >Add Full Installation</v-btn> -->
           
            <v-container>
              <v-data-table
                :headers="allInstallationHeaders"
                class="elevation-1"
                :rows-per-page-items="[25, 50, 100]"
                :loading="loading"
                :items="allInstallations"
                item-key="id"
                align-center
                disable-initial-sort
                :pagination.sync="installPagination"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    <v-icon @click="installation=props.item, addInstallationModal=true">remove_red_eye</v-icon>
                  </td>
                  <td class="text-xs-center">{{formatDate(props.item.createdAt)}}</td>
                  <td class="text-xs-center">{{props.item.installType}}</td>
                    <td class="text-xs-center"><span  v-if="props.item.installationDevices">
                <span v-for="installDevice in props.item.installationDevices" :key="installDevice.id"> {{ installDevice.device.ponMac }} <span v-if="props.item.installationDevices.indexOf(installDevice)<props.item.installationDevices.length-1"> - </span></span>
               </span></td>     
                  <td class="text-xs-center">
                    <v-icon v-if="props.item.patchLead" color="green">done</v-icon>
                    <v-icon v-else color="red">not_interested</v-icon>
                  </td>
                  <td class="text-xs-center">
                    <v-icon v-if="props.item.ftthBox" color="green">done</v-icon>
                    <v-icon v-else color="red">not_interested</v-icon>
                  </td>
                  <td class="text-xs-center">
                    <v-icon v-if="props.item.labelling" color="green">done</v-icon>
                    <v-icon v-else color="red">not_interested</v-icon>
                  </td>
                  <td class="text-xs-center">
                    <v-icon v-if="props.item.mstConnection" color="green">done</v-icon>
                    <v-icon v-else color="red">not_interested</v-icon>
                  </td>
                  <td class="text-xs-center">{{props.item.passiveDataReading}}</td>
                  <td class="text-xs-center">{{props.item.passiveVideoReading}}</td>
                  <td class="text-xs-center">{{props.item.activeDataReading}}</td>
                  <td class="text-xs-center">{{props.item.activeVideoReading}}</td>
                  <td class="text-xs-center" v-if="props.item.installedById !== null">{{props.item.installedBy.name}} {{props.item.installedBy.surname}}</td>
                  <td v-else></td>
                </template>
                <template
                  v-slot:pageText="props"
                >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
              </v-data-table>
            </v-container>
          </v-flex>
        </div>
        <div v-if="displayContents('showServiceAccounts')">
          <v-data-table
            :headers="serviceAccountHeaders"
            class="elevation-1"
            :search="search"
            :expand="expand"
            :loading="isloading"
            :items="serviceAccounts"
            :rows-per-page-items="[25, 50, 100, 250]"
            item-key="name"
            align-center
          >
            <template v-slot:items="props">
              <!-- <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
              </td>-->
              <td class="text-xs-center">
                <v-chip
                  small
                  dark
                  color="success"
                  v-if="((props.item.authenticationType==='PPPoE'&&props.item.pppoeUsername!==null&&props.item.pppoePassword!==null)||
        (props.item.authenticationType==='IPoE'&&props.item.IPoEMacAddress!==null))
        &&(props.item.fnoActivationDate!==null&&new Date(props.item.fnoActivationDate)<new Date())&&(props.item.fnoDeactivationDate===null||new Date(props.item.fnoDeactivationDate)>new Date())
          &&(props.item.ispActivationDate!==null&&new Date(props.item.ispActivationDate)<new Date())&&(props.item.ispDeactivationDate===null||new Date(props.item.ispDeactivationDate)>new Date())
        &&(props.item.deviceId!==null)&&(props.item.isActive===true)"
                >Active</v-chip>
                <v-chip
                  small
                  dark
                  color="blue"
                  v-else-if="(props.item.authenticationType==='PPPoE'&&(props.item.pppoeUsername===null||props.item.pppoePassword===null))
        ||((props.item.fnoActivationDate!==null&&new Date(props.item.fnoActivationDate)<new Date())
        &&(props.item.ispActivationDate===null||(props.item.ispActivationDate!==null&&new Date(props.item.ispActivationDate)>new Date())))
        &&(props.item.deviceId!==null)&&(props.item.isActive===true)"
                >ISP Action</v-chip>
                <v-chip
                  small
                  dark
                  color="warning"
                  v-else-if="(props.item.authenticationType==='IPoE'&&props.item.IPoEMacAddress===null)
        ||((props.item.fnoActivationDate===null))
        ||(props.item.deviceId===null)"
                >FNO Action</v-chip>
                <v-chip small dark color="red" v-else>Inactive</v-chip>
                <!-- <v-chip small dark color="success">Active</v-chip> -->
              </td>
              <td class="text-xs-center">{{props.item.packagesIsp.customerOrganisation.name}}</td>
               <td class="text-xs-center">{{props.item.innerVlan}}</td>
               <td class="text-xs-center">{{props.item.outerVlan}}</td>
              <td class="text-xs-center">{{props.item.packagesIsp.name}}</td>
              <td class="text-xs-center">{{props.item.packagesIsp.packagesFno.packageCode}}</td>
              <td class="text-xs-center">{{props.item.authenticationType}}</td>
              <td class="text-xs-center">{{props.item.pppoeUsername}}</td>
              <td class="text-xs-center">{{props.item.pppoePassword}}</td>
              <td class="text-xs-center">{{props.item.IPoEMacAddress}}</td>
              <td class="text-xs-center">{{formatDate(props.item.fnoActivationDate)}}</td>
              <td class="text-xs-center">{{formatDate(props.item.fnoDeactivationDate)}}</td>
              <td class="text-xs-center">{{formatDate(props.item.ispActivationDate)}}</td>
              <td class="text-xs-center">{{formatDate(props.item.ispDeactivationDate)}}</td>
              <td class="text-xs-center">{{props.item.staticIpv4}}</td>
              <td class="text-xs-center">{{props.item.staticIpv6}}</td>
            </template>
            <template
              v-slot:pageText="props"
            >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
          </v-data-table>
        </div>
        <div v-if="displayContents('showTransactions')">
          <transactions
            :locationid="this.$route.params.locationId"
            :locationnodeid="this.locationNodeId"
            :switchingcentreId="this.switchingCentreId"
            :locationnetworkid="this.locationNetworkId"
            :transactions="locationTransactions"
            :partners="Partners"
            :descriptionlist="descriptionList"
            :salesvalue="salesValue"
            :cosvalue="cosValue"
            :expensevalue="expenseValue"
            :loanvalue="loanValue"
            @refreshTotals="sum()"
            @transactionAdded="getTransactions()"
          ></transactions>
        </div>

        <div v-if="displayContents('documents')">
          <!-- <v-flex xs12 sm6 md6 lg6>
                <h3 class="pt-3 pb-3">
                  Files:
                  <v-icon color="primary" @click="uploadFileModal=true">add</v-icon>
                  <v-icon color="primary" @click="downloadFile">report</v-icon>
                
                </h3>
          </v-flex>-->
          <documentcomponent
            :locationid="this.$route.params.locationId"
            :documents="locationDocuments"
            @documentChange="fetchDocuments"
          ></documentcomponent>
        </div>
          <div v-if="displayContents('ticketSummary')" >
              <v-toolbar flat color="white">
            <v-layout>
              <v-spacer></v-spacer>
          <v-btn
        flat
        depressed
        rounded
        @click="addTicket(today); ticketAssignedLog= [];ticketCommentLog= [];"
        color="primary"
        class="white--text"
      >Add Ticket</v-btn>
    </v-layout>
    </v-toolbar>

      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          max-width="50px"
          class="pa-3"
          clearable
          ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
        :headers="ticketHeaders"
        class="elevation-1"
        :rows-per-page-items="[20, 50, 100, 250]"
        :pagination.sync="ticketPagination"
        :loading="isLoading"
        :items="ticketList"
        item-key="id"
        align-center
        style="cursor: pointer"
        hide-actions
        :key="key"
      >
       
        <template v-slot:items="props">
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.currentStatus.replace(/\s/g,'').toLowerCase()} white--text`"
              >{{props.item.currentStatus}}</v-chip>
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">{{props.item.id}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
            >{{props.item.ticketCategoryItem.ticketCategory.name}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
            >{{props.item.ticketCategoryItem.name}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.description"
              class="longText grey--text font-weight-light"
            >{{props.item.description}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
              v-if="props.item.dueTime === null"
            >{{formatDate(props.item.dueDate)}}</h3>
            <h3
              class="grey--text font-weight-light"
              v-else
            >{{formatDate(props.item.dueDate)}} {{props.item.dueTime}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.importance.replace(/\s/g,'').toLowerCase()} white--text`"
              >{{props.item.importance}}</v-chip>
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 v-if="props.item.createdById !==null"
              class="grey--text font-weight-light">{{props.item.createdBy.name}} {{props.item.createdBy.surname}}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.assignedTo !==null"
              class="grey--text font-weight-light"
            >{{props.item.assignedTo.name}} {{props.item.assignedTo.surname}}</h3>
            <h3 v-else class="grey--text font-weight-light">Unassigned</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.resolvedById !==null"
              class="grey--text font-weight-light"
            >{{props.item.resolvedBy.name}} {{props.item.resolvedBy.surname}}</h3>
          </td>
        </template>
            <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>

    <!-- Add ticket Modal -->
    <v-dialog v-model="addTicketModal" persistent max-width="900px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">ADD TICKET: {{ticketItem.dueDate}}</h3>
          <v-spacer></v-spacer>

          <v-btn
            v-if="ticketItem.ticketCategoryId&&ticketItem.ticketCategoryItemId&&ticketItem.currentStatus&&ticketItem.importance&&ticketItem.dueDate"
            flat
            color="white"
            class="white--text"
            @click="createNewTicket()"
          >Save</v-btn>
          <v-btn v-else disabled flat>Save</v-btn>
          <v-btn
            flat
            color="white"
            class="white--text"
            @click="addTicketModal=false, ticketItem={}"
          >X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center align-center>
            <v-flex>
              <v-checkbox label="Add from template" v-model="addTemplate"></v-checkbox>
            </v-flex>
            <v-flex v-if="addTemplate">
              <v-autocomplete
                v-model="ticketItem.ticketTemplateId"
                :items="ticketTemplates"
                clearable
                item-text="name"
                item-value="id"
                label="Ticket Template"
                @click:clear="clearTemplate()"
                v-on:change="populateTemplate()"
              ></v-autocomplete>
            </v-flex>
            <v-flex>
              <v-checkbox label="Full Day Event" v-model="dateTimeSelect"></v-checkbox>
            </v-flex>
            <v-flex>
              <VueCtkDateTimePicker
                :minDate="today"
                label="Select a Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketItem.dueDate"
              />
            </v-flex>
            <v-flex>
              <VueCtkDateTimePicker
                v-if="!dateTimeSelect"
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Select Time"
                only-time
                v-model="ticketItem.dueTime"
              />
            </v-flex>
          </v-layout>
          <v-layout >
            <v-flex xs4 mx-2>
                <v-autocomplete
                xs6
                :items="ticketCategories"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs4>
              <v-autocomplete
               v-if="ticketItem.ticketCategoryId"
                xs6
                :items="ticketCategoryItems.filter(x=>x.ticketCategoryId === ticketItem.ticketCategoryId &&x.isActive && !x.isDeleted)"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryItemId"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                xs6
                disabled
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
             <v-flex xs4 mx-2>
              <v-autocomplete
                v-model="ticketItem.assignedToId"
                :items="filteredUsers"
                :filter="filterObject"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assign Ticket to a User"
              >
                <template v-slot:selection="{ attr, on, item, selected }">
                  <v-chip
                    v-bind="attr"
                    :input-value="selected"
                    color="blue-grey"
                    class="white--text"
                    v-on="on"
                  >
                    <v-icon left>person</v-icon>
                    <span>{{item.name}} {{item.surname}}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-avatar
                    size="35px"
                    color="primary"
                    class="title font-weight-light white--text"
                    v-if="item!=='undefined'"
                  >{{ item.name.charAt(0) }}{{ item.surname.charAt(0) }}</v-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="grey--text ml-3">{{item.name}} {{item.surname}}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4 mx-2>
              <v-select :items="statuses" label="Status" v-model="ticketItem.currentStatus"></v-select>
            </v-flex>
            <v-flex xs4 mx-2>
              <v-select
                :items="importanceOptions"
                label="Importance"
                v-model="ticketItem.importance"
              ></v-select>
            </v-flex>
            <v-flex xs4 mx-2>
            </v-flex>
                     
          </v-layout>
          <v-layout justify-center align-center>
            <v-textarea label="Description" outline auto-grow v-model="ticketItem.description"></v-textarea>
          </v-layout>
          <v-layout justify-center v-if="ticketAssignedLog.length>0">
            <v-flex xs12>
              <h3 class="grey--text">Assignment Log:</h3>
            </v-flex>
            <v-flex xs12 v-for="assigned in ticketAssignedLog" :key="assigned">
              <v-layout justify-left align-center class="text-xs-left">
                <v-flex xs4>
                  <h3
                    class="grey--text"
                  >{{assigned.assignedBy.name}} {{assigned.assignedBy.surname}}</h3>
                </v-flex>
                <v-flex xs4>
                  <h3
                    class="grey--text"
                  >{{assigned.assignedTo.name}} {{assigned.assignedTo.surname}}</h3>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout justify-center align-center>
            <v-flex xs3>
              <h3 class="grey--text">Comments:</h3>
            </v-flex>
            <v-flex xs3>
              <v-icon color="primary" @click="addCommentBox=true">add_circle_outline</v-icon>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-if="ticketCommentLog.length===0&&!addCommentBox">
            <h3 class="grey--text font-weight-light">No Comments</h3>
          </v-flex>
          <v-flex xs12 v-if="addCommentBox">
            <v-textarea label="Comment" outline auto-grow v-model="comment"></v-textarea>
            <v-btn round color="primary" class="white--text" @click="addTicketComment(comment)">Comment</v-btn>
          </v-flex>
           <v-layout>
          <v-card flat style="overflow-y: auto; max-height:1000px" >
               <v-container style="text-align:left" >
                      <v-layout wrap>
          <v-flex xs12 v-for="comment in ticketCommentLog" :key="comment.createdAt">
            <v-layout justify-left align-center>
              <v-flex xs2>
                <span class="grey--text font-weight-light">{{formatDateTime(comment.createdAt)}}</span>
              </v-flex>
              <v-flex xs2>
                <span
                  class="grey--text font-weight-light"
                >{{comment.commentedBy.name}} {{comment.commentedBy.surname}}</span>
              </v-flex>
              <v-flex xs8>
                <span class="grey--text font-weight-light">{{comment.comment}}</span>
              </v-flex>
            </v-layout>
          </v-flex>
                      </v-layout>
               </v-container>
          </v-card>
           </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

        </div>
      </v-card>
    </v-card>

    <v-dialog v-model="deviceSearchModal" persistent max-width="1200px">
      <v-card flat colot="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text" fixed>Search for Device</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="deviceSearchModal=false">X</v-btn>
        </v-toolbar>
        <v-toolbar flat color="white"><v-spacer></v-spacer><v-text-field label="Search" v-model="searchDevice" v-on:keyup.enter="$router.push({name: $route.name, query:{offset: $route.query.offset, records: $route.query.records, search: searchDevice}})"></v-text-field></v-toolbar>
        <v-card-text>
         <v-data-table
         dense
      :headers="deviceHeaders"
      class="elevation-1"
      :items="allDevices"
      :rows-per-page-items="[20, 50, 100, 250]"
      :pagination.sync="devicePagination"
      item-key="id"
      align-center
      style="cursor: pointer"
      hide-actions
      :key="deviceLoadingKey"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-layout justify-center>
          <!-- <v-icon
            small
            @click="editItem(props.item)"
          >edit</v-icon> -->
          <v-icon  @click="saveSelectedDevice(props.item)" color="primary">add_circle</v-icon>
          <!-- <v-icon @click="viewDeviceDetails(props.item)">remove_red_eye</v-icon> -->
          <!-- <v-icon v-if="props.item.deviceMakeModelId!==null&&props.item.deviceMakeModel.deviceType.name==='OLT'">build</v-icon> -->
          </v-layout>
         </td>
        <td
          class="text-xs-center"
          @click="saveSelectedDevice(props.item)"
        >{{props.item.systemName}}</td>
        <td
          v-if="props.item.location"
          @click="saveSelectedDevice(props.item)"
          class="text-xs-center"
        >{{props.item.location.locationDescription}}</td>
        <td
        @click="saveSelectedDevice(props.item)"
          v-else
          class="text-xs-center"
        ></td>
        <td
        @click="saveSelectedDevice(props.item)"
          v-if="props.item.locationNetwork"
          class="text-xs-center"
        >{{props.item.locationNetwork.name}}</td>
        <td
        @click="saveSelectedDevice(props.item)"
          v-else
          class="text-xs-center"
        ></td>
        <td
        @click="saveSelectedDevice(props.item)"
          v-if="props.item.locationNode"
          class="text-xs-center"
        >{{props.item.locationNode.name}}</td>
        <td
        @click="saveSelectedDevice(props.item)"
          v-else
          class="text-xs-center"
        ></td>
          <td
          @click="saveSelectedDevice(props.item)"
          v-if="props.item.switchingCentre"
          class="text-xs-center"
        >{{props.item.switchingCentre.name}}</td>
        <td
        @click="saveSelectedDevice(props.item)"
          v-else
          class="text-xs-center"
        ></td>
        <!-- <td class="text-xs-center" v-else></td> -->
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center" v-if="props.item.deviceMakeModelId!==null">{{props.item.deviceMakeModel.deviceMake.name}}</td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center" v-else></td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center" v-if="props.item.deviceMakeModelId!==null">{{props.item.deviceMakeModel.deviceType.name}}</td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center" v-else></td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center" v-if="props.item.deviceMakeModelId!==null">{{props.item.deviceMakeModel.name}}</td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center" v-else></td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center">{{props.item.ipAddress}}</td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center">{{props.item.serialNumber}}</td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center">{{props.item.ponMac}}</td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center">{{props.item.macAddress}}</td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center">{{props.item.ponNumerical}}</td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center">{{props.item.productNumber}}</td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center" v-if="props.item.upstreamDeviceId!=null && props.item.upstreamDevice!= null&&typeof(props.item.upstreamDevice) != 'undefined'">{{props.item.upstreamDevice.deviceMakeModel.name}}</td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center" v-else></td>
          <td @click="saveSelectedDevice(props.item)" class="text-xs-center">{{props.item.ponAddress}}</td>
          <td @click="saveSelectedDevice(props.item)" class="text-xs-center">{{props.item.ponId}}</td>
          <td @click="saveSelectedDevice(props.item)" class="text-xs-center">{{props.item.frame}}</td>
          <td @click="saveSelectedDevice(props.item)" class="text-xs-center">{{props.item.slot}}</td>
          <td @click="saveSelectedDevice(props.item)" class="text-xs-center">{{props.item.port}}</td>
          <td @click="saveSelectedDevice(props.item)" class="text-xs-center">{{props.item.note}}</td>

        <td @click="saveSelectedDevice(props.item)" class="text-xs-center" v-if="props.item.isActive">
          <v-icon color="green">done</v-icon>
        </td>
        <td @click="saveSelectedDevice(props.item)" class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
      </template>
     
       
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >
      <!-- <div class="text-xs-center pt-2">
      <v-pagination v-model="pagination.page" :length="Math.ceil(pagination.totalItems/pagination.rowsPerPage)"></v-pagination>
    </div> -->
    Records {{ props.pageStart }} - {{ props.pageStop }} of {{ totalitems }}</template>
 
    </v-data-table>
     <div class="text-xs-center pt-2">
      <v-pagination v-model="page" :length="Math.ceil(devicePagination.totalItems/devicePagination.rowsPerPage)" :total-visible="7"></v-pagination>
    </div>
    </v-card-text>
      </v-card>

    </v-dialog>

    <!-- <v-dialog persistent v-model="deviceSearchModal" max-width="1000px">
      <devicesearchmodal
        :totalitems="allDevices.length"
        :devices="allDevices.filter(x=>x.locationNetworkId === locationdetail.locationNetworkId)"
        :loading="isLoading"
        @deviceSearchCancelled="deviceSearchModal=false"
      ></devicesearchmodal>
    </v-dialog> -->
  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
// import DeviceSearchModal from "@/components/DeviceSearchModal.vue";
import Transactions from "@/components/Transactions.vue";
import DocumentUpload from "@/components/Documents.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  props: ["locationdetail"],
  components: {
    transactions: Transactions,
    loading: Loading,
    documentcomponent: DocumentUpload,
    VueCtkDateTimePicker: VueCtkDateTimePicker
    // devicesearchmodal: DeviceSearchModal
  },

  data() {
    return {
       ticketCategoryItems: [],
      ticketCategories: [],
      addTemplate: false,
      ticketTemplates: [],
      dateTimeSelect: true,
      filteredUsers:[],
      ticketItem: {},
      comment: "",
      addCommentBox: false,
      statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
      importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
      ticketAssignedLog: [],
      ticketCommentLog: [],
      today: this.formatDateTime(new Date()),
      addTicketModal: false,
      ticketList:[],
      y: "top",
      upstreamDevices: [],
      newDialog: false,
      devicetab: false,
      page: 1,
      deviceLoadingKey: 0,
      totalDevices: 0,
      showFileUpload: false,
      uploadFileModal: false,
      additionalInformation: false,
      dialog: false,
      minimumDate: "",
      file: [],
      editCommentDialog: false,
      addCommentDialog: false,
      addButton: false,
      deviceSearch: false,
      searchDevice: "",
      commenttab: false,
      deviceComments: [],
      search2: "",
      customers: "",
      searchContacts: "",
      selectedDevice: [],
      devicePagination: {  totalItems: this.totalDevices, page: this.page},
      searchApplications: '',
      installPagination: {
          descending: true,
          sortBy: "createdAt"
      },
      ticketPagination: {
          descending: true,
          sortBy: "createdAt"
      },
      documentHeaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        }
      ],
      commentHeaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Date Time Stamp",
          align: "center",
          value: "dateTimeStamp"
        },
        {
          text: "Commenter",
          align: "center",
          value: "contact"
        },
        {
          text: "Comments",
          align: "center",
          value: "comments",
          width: "100%"
        }
      ],
      existingServiceAccountsHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Category",
          align: "center",
          sortable: false
        },
        {
          text: "ISP Name",
          align: "center",
          value: "name"
        },
        {
          text: "ISP Package Code",
          align: "center",
          value: "packagesIspIdname"
        }
      ],
      deviceHeaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "System Name",
          align: "center",
          value: "systemName"
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Make",
          align: "center",
          value: "deviceMakeModel.deviceMake.name"
        },
        {
          text: "Type",
          align: "center",
          value: "deviceMakeModel.deviceType.name"
        },
        {
          text: "Model",
          align: "center",
          value: "deviceMakeModel.name"
        },
        {
          text: "IP Address",
          align: "center",
          value: "ipAddress"
        },
        {
          text: "Serial Number",
          align: "center",
          value: "serialNumber"
        },
        {
          text: "Pon Mac",
          align: "center",
          value: "ponMac"
        },
        {
          text: "Mac Address",
          align: "center",
          value: "macAddress"
        },
        {
          text: "Pon Numerical",
          align: "center",
          value: "ponNumerical"
        },
        {
          text: "Product Number",
          align: "center",
          value: "productNumber"
        },

        {
          text: "Upstream Device",
          align: "center",
          value: "upstreamDevice.deviceMakeModel.name"
        },
        {
          text: "PON Address",
          align: "center",
          value: "ponAddress"
        },
        {
          text: "PON ID",
          align: "center",
          value: "ponId"
        },
        {
          text: "Frame",
          align: "center",
          value: "frame"
        },
        {
          text: "Slot",
          align: "center",
          value: "slot"
        },
        {
          text: "Port",
          align: "center",
          value: "port"
        },
        {
          text: "Note",
          align: "center",
          value: "note"
        },
        {
          text: "Active",
          align: "center",
          value: "isActive"
        }
      ],
      vlans: null,
      authenticationType: [],
      packagesIsp: [],
      checkEmail: false,
      LocationDetailLoading: true,
      passiveInstallations: [],
      activeInstallations: [],
      contactTypes: [],
      upstreamDevices: [],
      deviceSearchModal: false,
      totals: [],
      allTotals: [],
      salesValue: "",
      cosValue: "",
      expenseValue: "",
      isloading: false,
      isLoading: true,
      loanValue: "",
      locationTransactions: [],
      Partners: [{ id: 1, name: "Fibre Geeks" }],
      search: "",
      createContactModal: false,
      addDevice: false,
      createNewDevice: false,
      addInstallationModal: false,
      addContactModal: false,
      editContactModal: false,
      editDeviceModal: false,
      addDeviceModal: false,
      activeTabName: null,
      Contacts: [],
      locationInfo: [],
      installationInfo: [],
      allContacts: [],
      locationNetworkId: "",
      locationNodeId: "",
      serviceAccounts: [],
      devices: [],
      deviceMakeModelId: "",
      deviceMakeModel: [],
      locationDevices: [],
      existingServiceAccounts: [],
      allDevices: [],
      selectedLocation: "",
      installation: [],
      loading: false,
      unusedDevices: [],
      allInstallations: [],
      locationDocuments: [],
      expand: false,
      selected: {},
      pagination: {},
      descriptionList: [],
      addServiceAccountModal: false,
      customerId: null,
      activeInstallTab: '',
      text: '',
      errorText: '',
      snackbar: false,
      errorSnackbar: false,
      applicationHeaders: [
        // {
        //   text: "Actions",
        //   align: "center"
        // },
        {
          text: "Status",
          align: "center",
          value: "isResolved"
        },
        {
          text: "Submitted",
          align: "center",
          value: "createdAt"
        },
        {
          text: "Application ID",
          align: "center",
          value: "id"
        },
        {
          text: "Contact Name",
          align: "center",
          value: "primaryContactName"
        },
        {
          text: "Mobile Number",
          align: "center",
          value: "primaryContactMobileNumber"
        },
        {
          text: "Email Address",
          align: "center",
          value: "primaryContactEmailAddress"
        },
        {
          text: "Comment",
          align: "center",
          value: "comment"
        },
        {
          text: "ISP",
          align: "center",
          value: "packagesIsp.customerOrganisation.name"
        },
        {
          text: "ISP Package Selected",
          align: "center",
          value: "packagesIsp.name"
        },
        {
          text: "Service Account ID",
          align: "center",
          value: "serviceAccountId"
        }
      ],
      serviceAccountHeaders: [
        // {
        //   text: "Action",
        //   align: "center",
        //   sortable: false
        // },
        {
          text: "Status",
          align: "center",
          sortable: false
        },
        {
          text: "ISP Name",
          align: "center",
          value: "customer.name"
        },
        {
          text: "Inner VLAN",
          align: "center",
          value: "innerVlan"
        },
        {
          text: "Outer VLAN",
          align: "center",
          value: "outerVlan"
        },
        {
          text: "ISP Package",
          align: "center",
          value: "packagesIsp.name"
        },
        {
          text: "FNO Package Code",
          align: "center",
          value: "packagesIsp.packagesFno.packageCode"
        },
        {
          text: "Auth Type",
          align: "center",
          value: "authenticationType"
        },
        {
          text: "PPPoE Username",
          align: "center",
          value: "pppoeUsername"
        },
        {
          text: "PPPoE Password",
          align: "center",
          value: "pppoePassword"
        },
        {
          text: "IPoE MAC Address",
          align: "center",
          value: "IPoEMacAddress"
        },
        {
          text: "FNO Activation Date",
          align: "center",
          value: "fnoActivationDate"
        },
        {
          text: "FNO Deactivation Date",
          align: "center",
          value: "fnoDeactivationDate"
        },
        {
          text: "ISP Activation Date",
          align: "center",
          value: "ispActivationDate"
        },
        {
          text: "ISP Deactivation Date",
          align: "center",
          value: "ispDeactivationDate"
        },
        {
          text: "Static Ipv4",
          align: "center",
          value: "staticIpv4"
        },
        {
          text: "Static Ipv6",
          align: "center",
          value: "staticIpv6"
        }
      ],
      allInstallationHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Installation Date",
          align: "center",
          value: "createdAt"
        },
        {
          text: "Install Type",
          align: "center",
          value: "installType"
        },
          {
          text: "Device",
          align: "center",
          value: "installationDevices"
        },
        {
          text: "Patch Lead",
          align: "center",
          value: "patchLead"
        },
        {
          text: "FTTH Box",
          align: "center",
          value: "ftthBox"
        },
        {
          text: "Labelling",
          align: "center",
          value: "labelling"
        },
        {
          text: "MST Connection",
          align: "center",
          value: "mstConnection"
        },
        {
          text: "Passive Data",
          align: "center",
          value: "passiveDataReading"
        },
        {
          text: "Passive Video",
          align: "center",
          value: "passiveVideoReading"
        },
        {
          text: "Active Data",
          align: "center",
          value: "activeDataReading"
        },
        {
          text: "Active Video",
          align: "center",
          value: "activeVideoReading"
        },
        {
          text: "Installed By",
          align: "center",
          value: "installedBy.name"
        }
      ],
       ticketHeaders: [
        {
          text: "Status",
          align: "center",
          value: "currentStatus"
        },
        {
          text: "Ticket ID",
          align: "center",
          value: "id"
        },
        {
          text: "Category",
          align: "center",
          value: "ticketCategoryItem.ticketCategory.name"
        },
        {
          text: "Subcategory",
          align: "center",
          value: "ticketCategoryItem.name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Due",
          align: "center",
          value: "dueDate"
        },
        {
          text: "Priority",
          align: "center",
          value: "importance"
        },
        {
          text: "Created By",
          align: "center",
          value: "createdBy.name"
        },
        {
          text: "Assigned To",
          align: "center",
          value: "assignedTo.name"
        },
        {
          text: "Resolved By",
          align: "center",
          value: "resolvedBy.name"
        }
      ],
      tabs: [
        { name: "summary", displayName: "Summary" },
        { name: "showApplications", displayName: "Applications" },
        // { name: "showInstallations", displayName: "Installations" },
        { name: "showServiceAccounts", displayName: "Service Accounts" },
        // { name: "showTransactions", displayName: "Transactions" },
        { name: "deviceContents", displayName: "Devices" },
        // { name: "documents", displayName: "Documents" },
        // { name: "ticketSummary", displayName: "Tickets" },
      ],
      installTabs: [
        { name: "installSummary", displayName: "Summary" },
        { name: "passiveInstall", displayName: "Passive Install" },
        { name: "activeInstall", displayName: "Active Install" }
      ],
      contactHeaders: [
        {
          text: "Actions",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Surname",
          align: "center",
          value: "surname"
        },
        {
          text: "ID Number",
          align: "center",
          value: "idNumber"
        },
        {
          text: "Mobile",
          align: "center",
          value: "mobileNumber"
        },
        {
          text: "Telephone",
          align: "center",
          value: "telephoneNumber"
        },
        {
          text: "Email",
          align: "center",
          value: "emailAddress"
        }
      ],
      headers: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Unit Number",
          align: "center",
          value: "unitNo"
        },
        {
          text: "Sub Complex",
          align: "center",
          value: "subComplexName"
        }
      ],
      installation: {
        patchLead: false,
        ftthBox: false,
        labelling: false,
        mstConnection: false,
        passiveDataReading: "",
        passiveVideoReading: "",
        activeDataReading: "",
        activeVideoReading: "",
        connectionName: "",
        connectionPassword: "",
        timeStamp: "",
        locationId: null,
        activeInstallComplete: false,
        passiveInstallComplete: false,
        isActiveInstall: false,
        isPassiveInstall: false,
        isActive: true,
        isDeleted: false
      },
      defaultInstallation: {
        patchLead: false,
        ftthBox: false,
        labelling: false,
        mstConnection: false,
        passiveDataReading: "",
        passiveVideoReading: "",
        activeDataReading: "",
        activeVideoReading: "",
        connectionName: "",
        connectionPassword: "",
        timeStamp: "",
        locationId: null,
        activeInstallComplete: false,
        passiveInstallComplete: false,
        isActiveInstall: false,
        isPassiveInstall: false,
        isActive: true,
        isDeleted: false
      },
      editedItem: {
        id: "",
        serialNumber: "",
        ponMac: "",
        macAddress: "",
        ponNumerical: "",
        productNumber: "",
        deviceMakeModel: [],
        deviceMakeModelId: null,
        locationNetworkId: "",
        locationNodeId: "",
        ipAddress: "",
        systemName: "",
        location: "",
        locationId: null,
        port: null,
        frame: null,
        slot: null,
        upstreamDeviceId: null,
        ponId: null,
        note: "",
        fileDescription: "",
        isActive: true,
        isDeleted: false,

        permissions: "",
        name: "",
        customerId: "",
        locationContactId: "",
        contactTypeId: "",
        surname: "",
        idNumber: "",
        mobileNumber: "",
        telephoneNumber: "",
        emailAddress: "",
        password: "",

        locationId: "",
        deviceId: null,
        serviceAccountIdentifier: "",
        initialActivation: "",
        customerId: null,
        vlanId: null,
        packagesIspId: "",
        authenticationType: "",
        pppoeUsername: "",
        pppoePassword: "",
        IPoEMacAddress: null,
        fnoActivationDate: "",
        fnoDeactivationDate: "",
        ispActivationDate: "",
        ispDeactivationDate: "",
        staticIpv4: "",
        staticIpv6: "",
        isChange: "",
        requestType: "",
        IPoEActive: null,
        isActive: true,
        isDeleted: false,
        locationId: "",
        serviceAccountIdentifier: "",
        locationDescription: "",
        toSpeedProfileId: "",
        isChange: "",
        ispName: "",
        requestType: "",
        isChange: "",
        ispContactName: "",
        fnoContactName: "",
        fromSpeedProfile: "",
        toSpeedProfile: "",
        toSpeedProfileName: "",
        customerId: this.$store.state.customerId,
        changePackagesIspId: "",
        packagesIspId: "",
        authenticationType: "",
        pppoeUsername: "",
        pppoePassword: "",
        initialActivation: null,
        fnoActivationDate: "",
        fnoDeactivationDate: "",
        ispActivationDate: "",
        ispDeactivationDate: "",
        staticIpv4: "",
        staticIpv6: "",
        IPoEActive: ""
      },
      defaultItem: {
        serialNumber: "",
        ponMac: "",
        macAddress: "",
        ponNumerical: "",
        productNumber: "",
        deviceMakeModel: [],
        deviceMakeModelId: null,
        locationNetworkId: "",
        locationNodeId: "",
        location: "",
        locationId: null,
        upstreamDeviceId: "",
        isActive: "",
        isDeleted: ""
      },
      editedCommentItem: {
        deviceId: null,
        contactId: null,
        comments: "",
        dateTimeStamp: "",
        isActive: true,
        isDeleted: false
      }
    };
  },
  created() {
    (this.LocationDetailLoading = true), this.initialize();
    this.setActiveInstallTabName('installSummary')
  },
  watch: {
    'pagination.rowsPerPage': {
      immediate: true,
      handler(value){
      if(value&&value!=""&&value != this.$route.query.records){
        if(this.$route.query.search){
        this.$router.push({name: this.$route.name, query:{offset: this.$route.query.offset, records: value, search: this.$route.query.search}})
        } else {
        this.$router.push({name: this.$route.name, query:{offset: this.$route.query.offset, records: value}})
        }
      }
      }
    },
    'pagination.page': {
      immediate: true,
      handler(value){
      if(value&&value!=""&&value != this.$route.query.records){
        if(this.$route.query.search){
          this.$router.push({name: this.$route.name, query:{offset: value*this.$route.query.records, records: this.$route.query.records, search: this.$route.query.search}})
        } else {
        this.$router.push({name: this.$route.name, query:{offset: value*this.$route.query.records, records: this.$route.query.records}})
      }
      }
    }
  },
  page(value){
    if(value&&value!=""&&value != this.$route.query.records){
        if(this.$route.query.search){
          this.$router.push({name: this.$route.name, query:{offset: (value-1)*this.$route.query.records, records: this.$route.query.records, search: this.$route.query.search}})
        } else {
        this.$router.push({name: this.$route.name, query:{offset: (value-1)*this.$route.query.records, records: this.$route.query.records}})
      }
      }
  },
      '$route.query.search':{
      immediate: true,
      handler(value){
        // this.devices= await this.search(value.search)
        this.isLoading=true
      if(this.$route.query.search&&value!==""&&value != null){      
        // debugger
        Api()
        .get('/devices/active',{
          params: {
          search: value,
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.page=1
          this.allDevices=response.data.result
          this.devicePagination.totalItems = response.data.count;
          this.deviceLoadingKey+=1
            this.isLoading=false
          })} else if(value==""||value == null) {
            // debugger
             Api()
        .get('/devices/active',{
          params: {
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.page=1
          this.allDevices=response.data.result
          this.devicePagination.totalItems = response.data.count;
          this.deviceLoadingKey+=1
            // this.devicesLength=this.devices.length
            this.isLoading=false})
            // this.fetchDevices()
            // // debugger
          }
      }
    },
    '$route.query.offset': {
       immediate: true,
      handler(value){
        // this.devices= await this.search(value.search)
        this.isLoading=true
      if(value!==""&&value != null&&this.$route.query.search&&this.$route.query.search!="" &&this.$route.query.search!== null){      
        
        Api()
        .get('/devices/active',{
          params: {
          search: this.$route.query.search,
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.allDevices=response.data.result
          this.devicePagination.totalItems = response.data.count;
          this.deviceLoadingKey+=1
            this.isLoading=false})
      } else if(value!==""&&value != null){
        // debugger
         Api()
        .get('/devices/active',{
          params: {
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.allDevices=response.data.result
          this.devicePagination.totalItems = response.data.count;
          this.deviceLoadingKey+=1
            this.isLoading=false})
      }
    }},
    "$route.params.locationId": {
      immediate: true,
      handler(value) {
        if (value !== null && typeof value !== "undefined" && value !== "") {
          this.initialize();
        }
      }
    },
    customerId(value) {
      this.locationNetworks = [];
      this.locations = [];
      if (value !== null) {
        const route = { name: this.$route.name };
        route.query = route.query = {};
        this.$router.push(route);
        this.editedItem.vlanId = null;
        this.loadingFinished = false;
        Api()
          .get("/vlans/byCustomer/" + value)
          .then(response => {
            this.vlans = response.data;
          });
        Api()
          .get(
            "/packagesIsps/packagesOnNetwork/" +
              value +
              "/" +
              this.locationNetworkId,
            {
              params: {
                customerId: value
              }
            }
          )
          .then(response => {
            this.locationNetworks = [];
            this.locationNetworksArray = [];
            this.locations = [];
            for (var i = 0; i < response.data.length; i++) {
              if (
                !this.locationNetworksArray.includes(
                  response.data[i].locationNetworkId
                )
              ) {
                this.locationNetworksArray.push(
                  response.data[i].locationNetworkId
                );
                this.locationNetworks.push(response.data[i].locationNetwork);
              }
            }
            for (var z = 0; z < this.locationNetworks.length; z++) {
              for (
                var a = 0;
                a < this.locationNetworks[z].locations.length;
                a++
              ) {
                this.locations.push(this.locationNetworks[z].locations[a]);
              }
            }
            this.loadingFinished = true;
            this.totalItems = this.locations.length;
          });
      }
    },
    "$route.query.selectedLocation": {
      immediate: true,

      handler(value) {
        if (value !== "" && value !== null && typeof value !== "undefined") {
          this.existingServiceAccounts = [];
          this.selectedLocationSearch = true;
          this.editedItem.locationId = value;
          Api()
            .get("/locations/" + value)
            .then(response => {
              this.selectedLocation = response.data[0];
              Api()
                .get("/serviceAccounts/byLocation/" + this.selectedLocation.id)
                .then(response => {
                  this.existingServiceAccounts = response.data;
                });
              // Api()
              //   .get(
              //     "/packagesIsps/packagesOnNetwork/" +
              //       this.customerId +
              //       "/" +
              //       this.selectedLocation.locationNetworkId
              //   )
              //   .then(response => {
              //     this.packagesIsp = response.data;
              //   });
            });
          this.loading = true;
          Api()
            .get("/devices/byLocation/" + value)
            .then(response => {
              this.locationDevices = response.data;
              this.loading = false;
            });
        } else {
          this.selectedLocationSearch = false;
        }
      }
    },

    deviceMakeModelId(value) {
      if (value !== "" && value !== null && typeof value !== "undefined") {
        Api()
          .get("/devices/" + value)
          .then(response => {
            let upstreamId = null;
            try {
              upstreamId =
                response.data[0].deviceMakeModel.deviceType
                  .upstreamDeviceTypeId;
            } catch {
              upstreamId = false;
            }
            if (upstreamId) {
              Api()
                .get(
                  "/devices/showUpstreamDevicesbyNetwork/" +
                    this.locationNodeId +
                    "/" +
                    this.$route.params.locationNetworkId +
                    "/" +
                    upstreamId
                )
                .then(response => {
                  this.upstreamDevices = response.data;
                });
            }
          });
      }
    },
    // "$route.query.searchDevices": {
    //   immediate: true,
    //   handler(value) {
    //     if (value !== "" && value !== null && typeof value !== "undefined") {
    //       if (this.$route.query.searchDevices) {
    //         this.isLoading = true;
    //         Api()
    //           .get("/devices", {
    //             params: {
    //               search: this.$route.query.searchDevices
    //             }
    //           })
    //           .then(response => {
    //             this.allDevices = response.data;
    //             this.isLoading = false;
    //           });
    //       } else {
    //         this.isLoading = true;
    //         Api()
    //           .get("/devices")
    //           .then(response => {
    //             this.allDevices = response.data;
    //             this.isLoading = false;
    //           });
    //       }
    //     }
    //   }
    // },
    // "$route.query.selectedDevice": {
    //   immediate: true,
    //   handler(value) {
    //     if (value !== "" && value !== null && typeof value !== "undefined") {
    //       Api()
    //         .put("/devices/" + this.$route.query.selectedDevice, {
    //           locationId: this.$route.params.locationId,
    //           locationNetworkId: this.locationNetworkId,
    //           locationNodeId: this.locationNodeId
    //         })
    //         .then(this.getDevices());
    //     }
    //   }
    // }
  },
  methods: {
      updatePassiveInstallStatus(){
          Api().put('/locations/'+this.locationInfo.id, {
              fibrePulled: !this.locationInfo.fibrePulled
          }).then(response=>{
              this.locationInfo.fibrePulled = !this.locationInfo.fibrePulled
          })
      },
     fetchTicketCategories() {
      Api()
        .get("/ticketCategory")
        .then(response => {
          this.ticketCategories = response.data;
        });
    },
    fetchTicketCategoryItems() {
      Api()
        .get("/ticketCategoryItem")
        .then(response => {
          this.ticketCategoryItems = response.data;
          this.ticketKey += 1;
        });
    },
    clearTemplate() {
      this.ticketItem.dueDate = "";
      this.ticketItem.dueTime = "";
      this.ticketItem.assignedToId = null;
      this.ticketItem.ticketCategoryItemId = null;
      this.ticketItem.ticketCategoryId = null;
    },
    populateTemplate() {
      this.clearTemplate();
      for (let i = 0; i < this.ticketTemplates.length; i++) {
        if (this.ticketTemplates[i].id === this.ticketItem.ticketTemplateId) {
          this.ticketItem.dueDate = this.ticketTemplates[i].dueDate;
          this.ticketItem.dueTime = this.ticketTemplates[i].dueTime;
          this.ticketItem.assignedToId = this.ticketTemplates[i].contactId;
          if (this.ticketTemplates[i].ticketCategoryItem !== null) {
            this.ticketItem.ticketCategoryItemId = this.ticketTemplates[
              i
            ].ticketCategoryItemId;
            this.ticketItem.ticketCategoryId = this.ticketTemplates[
              i
            ].ticketCategoryItem.ticketCategoryId;
          }
        }
      }
    },
      async createNewTicket() {
        this.ticketItem.locationId=this.$route.params.locationId
      await Api()
        .post("/ticket", this.ticketItem)
        .then(response => {
          if (this.ticketCommentLog.length > 0) {
            for (let i = 0; i < this.ticketCommentLog.length; i++) {
              this.ticketCommentLog[i].ticketId = response.data.id;
            }
            Api()
              .post("/ticketComment", {
                batch: this.ticketCommentLog
              })
              .then(response => {});
          }
          if (this.ticketItem.assignedToId) {
            Api().post("/ticketAssignLog", {
              assignedToId: this.ticketItem.assignedToId,
              assignedById: this.ticketItem.assignedById,
              ticketId: response.data.id
            });
          }
            this.fetchTickets()
            this.addTicketModal = false;
            this.ticketItem = {};
        });
     
    },
     addTicketComment(comment) {
      this.ticketCommentLog.push({
        commentedBy: this.$store.state.user,
        commentedById: this.$store.state.user.id,
        comment: comment,
        type: "comment",
        createdAt: new Date()
      });
      this.comment = "";
      this.addCommentBox = false;
    },
     async editTicket(item) {
      this.$router.push({ path: "/ticketSummary/" + item });
    },
      addTicket(date) {
      if (date == null) {
        this.addTicketModal = true;
        this.ticketItem = {
          importance: "Normal",
          currentStatus: "Pending",
          dueDate: new Date()
        };
      } else {
        this.ticketItem = {
          importance: "Normal",
          currentStatus: "Pending",
          dueDate: date
        };
        this.addTicketModal = true;
      }
    },
    fetchTickets(){
        Api()
        .get('/ticket/byLocation/'+ this.$route.params.locationId)
        .then(response=>{
            this.ticketList = response.data
        })
    },
    saveSelectedDevice(item){
      Api()
            .put("/devices/" + item.id, {
              locationId: this.$route.params.locationId,
              locationNetworkId: this.locationNetworkId,
              locationNodeId: this.locationNodeId
            })
            .then(response=>{
                
                Api().put('/locations/'+this.locationInfo.id,{
                    equipmentInstalled: true
                }).then(response=>{
                    this.locationInfo.equipmentInstalled = true
                })
                this.getDevices()
            });
    },
    selectFile(event) {
      this.file = event.srcElement.files[0];
    },
    downloadFile(id) {
      Api()
        .get("/upload/" + id)
        .then(response => {
          let file = Buffer.from(response.data.base64, "base64");
          const linkSource = `data:${response.data.type};base64,${response.data.base64}`;
          const downloadLink = document.createElement("a");
          const fileName = response.data.name;

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        });
    },
    async uploadFile() {
      var reader = new FileReader();
      await reader.readAsBinaryString(this.file);
      let file = "";
      let locationId = this.$route.params.locationId;
      let locationNetworkId = this.$route.params.locationNetworkId;
      let name = this.file.name;
      let type = this.file.type;
      let description = this.editedItem.fileDescription;
      reader.onload = function() {
        file = btoa(reader.result);
        Api().post("/upload", {
          description: description,
          name: name,
          type: type,
          isActive: true,
          isDeleted: false,
          locationId: locationId,
          locationNetworkId: locationNetworkId,
          locationNodeId: null,
          base64: file
        });
      };
      reader.onerror = function() {
        console.log("there are some problems");
      };

      this.uploadFileModal = false;
    },
    fetchDocuments() {
      Api()
        .get("/upload/byLocation/" + this.$route.params.locationId)
        .then(response => {
          this.locationDocuments = response.data;
        });
    },
    // searchDevices(search) {
    //   this.isLoading = true;
    //   if (search.search !== "") {
    //     Api()
    //       .get("/devices/byLocation", {
    //         params: {
    //           search: search.search
    //         }
    //       })
    //       .then(response => {
    //         this.devices = response.data;
    //         this.isLoading = false;
    //       });
    //   }
    // },
    cancelFields() {
      (this.associatedLocationType = ""),
        (this.switchingCentreId = null),
        (this.locationNodeId = null),
        (this.locationNetworkId = null),
        (this.editedItem.locationId = null),
        (this.selectedLocation = []),
        (this.selectedDevice = []);

      this.editedItem = {};
    },
    async requestServiceAccountChange(item) {
      this.editedItem = Object.assign({}, item);
      this.editedItem.packagesIspId = item.packagesIspId;
      this.editedItem.customerId = item.packagesIsp.customer.id;
      this.customerId = this.editedItem.customerId;
      this.editedItem.locationId = item.locationId;
      this.editedItem.vlanId = item.vlanId;
      this.locationNetworkId = item.location.locationNetworkId;
      await Api()
        .get("/locations/" + item.locationId)
        .then(response => {
          this.selectedLocation = response.data[0];
        });
      await Api()
        .get("/vlans/byCustomer/" + this.customerId)
        .then(response => {
          this.vlans = response.data;
        });
      await this.getIspPackagesAtLocation();
      Api()
        .get("/devices/byLocation/" + this.editedItem.locationId)
        .then(response => {
          this.locationDevices = response.data;
        });
      await this.getPendingRequests();
      this.selectedLocationSearch = true;
      this.serviceAccountChange = true;
    },
    fetchCustomers() {
      Api()
        .get("/customers")
        .then(response => {
          this.customers = response.data;
          this.LocationDetailLoading = false;
        });
    },
    // fetchUpstreamDevices() {
    //   (this.loading = true),
    //     Api()
    //       .get("/devices/active")
    //       .then(response => {
    //         this.upstreamDevices = response.data;
    //         this.loading = false;
    //       });
    // },
     checkDevice(item){
        Api().put("/devices/" + item.id , {
          locationId: this.$route.params.locationId,
          locationNetworkId: this.locationNetworkId,
          locationNodeId: this.locationNodeId,
          switchingCentreId: this.switchingCentreId,
          isDeleted: this.editedItem.isDeleted,
          isActive: this.editedItem.isActive
          })
          .then(response => {
            Api()
            .put('/locations/'+this.$route.params.locationId,{
              equipmentInstalled: true,
              fibrePulled: true
            }).then(response=>{
              this.locationInfo.fibrePulled=true,
              this.locationInfo.equipmentInstalled=true
            })
            this.$emit("devicesSaved");
            this.getDevices();
          });
           this.deviceSearch = false;
    },
    clearComments() {
      (this.editedCommentItem.contactId = null),
        (this.editedCommentItem.dateTimeStamp = ""),
        (this.editedCommentItem.comments = ""),
        (this.editedCommentItem.deviceId = null);
    },
    clearAndSetDeviceFlags(id) {
      this.selectedDevice = [];
      for (let i = 0; i < this.upstreamDevices.length; i++) {
        this.upstreamDevices[i].flag = false;
        if (this.upstreamDevices[i].id == id) {
          this.upstreamDevices[i].flag = true;
          this.selectedDevice = [];
          this.selectedDevice.push(this.upstreamDevices[i]);
        }
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    addButtonFunc() {
      this.addButton = false;
    },
    async fetchUnusedDevices() {
      this.isLoading = true;
      await this.$router.push({name: this.$route.name, query:{offset: '0', records: '20'}});
      this.deviceSearchModal=true
      // Api()
      //   .get("/devices/unused")
      //   .then(response => {
      //     this.unusedDevices = response.data;
      //     this.isLoading = false;
      //   });
      // Api()
      //   .get("/devices/active",{
      //     params:{
      //       offset: this.$route.query.offset,
      //       records: this.$route.query.records
      //     }
      //   })
      //   .then(response => {
      //     this.allDevices = response.data;
      //     this.isLoading = false;
      //   });
    },
    sum() {
      this.totals = [];
      this.salesValue = 0;
      this.cosValue = 0;
      this.expenseValue = 0;
      this.loanValue = 0;
      var res = {};

      this.locationTransactions.forEach(function(el) {
        res[el.transactionType] = res[el.transactionType]
          ? (res[el.transactionType] += +el.amount)
          : +el.amount;
      });
      // for (let i=0; i< res.length;i++){

      // }
      this.totals.push(
        Object.keys(res).map(function(el) {
          return { transactionType: el, amount: res[el] };
        })
      );
      for (let i = 0; i < this.totals[0].length; i++) {
        if (this.totals[0][i].transactionType === "Sales") {
          this.salesValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Cost of Sales") {
          this.cosValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Expense") {
          this.expenseValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Loan") {
          this.loanValue = this.totals[0][i].amount;
        }
      }
    },
    calculateTotals(transactions) {
      this.allTotals = [];
      var res = {};

      transactions.forEach(function(el) {
        res[el.transactionType] = res[el.transactionType]
          ? (res[el.transactionType] += +el.amount)
          : +el.amount;
      });
      this.allTotals.push(
        Object.keys(res).map(function(el) {
          return { transactionType: el, amount: res[el] };
        })
      );
      for (let i = 0; i < this.allTotals[0].length; i++) {
        if (this.allTotals[0][i].transactionType === "Sales") {
          this.salesValue = this.allTotals[0][i].amount;
        }
        if (this.allTotals[0][i].transactionType === "Cost of Sales") {
          this.cosValue = this.allTotals[0][i].amount;
        }
        if (this.allTotals[0][i].transactionType === "Expense") {
          this.expenseValue = this.allTotals[0][i].amount;
        }
        if (this.allTotals[0][i].transactionType === "Loan") {
          this.loanValue = this.allTotals[0][i].amount;
        }
      }
    },
    getTransactions() {
      this.descriptionList = [];
      Api()
        .get("/transactions/byLocation/" + this.$route.params.locationId)
        .then(response => {
          this.locationTransactions = response.data;
          // for (let i = 0; i < this.locationTransactions.length; i++) {
          //   if (
          //     !this.descriptionList.includes(
          //       this.locationTransactions[i].description
          //     )
          //   ) {
          //     this.descriptionList.push(
          //       this.locationTransactions[i].description
          //     );
          //   }
          // }
          this.calculateTotals(this.locationTransactions);
          this.LocationDetailLoading = false;
          //   this.transactionsByMonth();
        });
    },
    async fetchInstallations() {
      Api().get('/installations/byLocation/'+this.$route.params.locationId).then(response=>{
        this.allInstallations = response.data
      })
      // Api()
      //   .get(
      //     "/installations/passiveInstallsbyLocation/" +
      //       this.$route.params.locationId
      //   )
      //   .then(response => {
      //     this.passiveInstallations = response.data;
      //   });
      // Api()
      //   .get(
      //     "/installations/activeInstallsbyLocation/" +
      //       this.$route.params.locationId
      //   )
      //   .then(response => {
      //     this.activeInstallations = response.data;
      //   });
    },
    deleteDevice(id) {
      confirm("Are you sure you want to remove this device from this location?") &&
        Api()
          .put("/devices/" + id, {
            // isActive: false,
            // isDeleted: true
            locationId: null,
            locationNetworkId: null,
            locationNodeId: null,
            switchingCentreId: null
          })
          .then(response => {
            this.getDevices();
            this.$emit("devicesSaved");
          });
    },
    fetchDeviceMakeModels() {
      Api()
        .get("/deviceMakeModels/active")
        .then(response => {
          this.deviceMakeModel = response.data;
        });
    },
    removeContact(item) {
      this.editedItem = Object.assign({}, item.contact);
      this.editedItem.contactTypeId = item.contactTypeId;
      this.editedItem.locationContactId = item.id;
      Api()
        .put("/LocationContact/" + this.editedItem.locationContactId, {
          locationId: this.$route.params.locationId,
          contactId: this.editedItem.id,
          contactTypeId: this.editedItem.contactTypeId,
          isDeleted: true,
          isActive: false
        })
        .then(response => {
          this.getContacts();
        });
    },
    fetchContactTypes() {
      Api()
        .get("/contactTypes")
        .then(response => {
          this.contactTypes = response.data;
        });
    },
    resetPassword() {
      Api().put("/contacts/resetPassword/" + this.editedItem.id, {
        name: this.editedItem.name,
        surname: this.editedItem.surname,
        idNumber: this.editedItem.idNumber,
        mobileNumber: this.editedItem.mobileNumber,
        password: this.editedItem.password,
        telephoneNumber: this.editedItem.telephoneNumber,
        emailAddress: this.editedItem.emailAddress,
        isActive: this.editedItem.isActive,
        password: this.editedItem.password
      });
      this.$emit("contactsSaved");
      this.close();
    },
    async routerLinkToDetails(item) { 
      let url =item
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/applications/:applicationId'})
      await this.$store.dispatch('setCurrentRoute', route[0])
      this.editedItem = Object.assign({}, item);
      this.$router.push({ path: "/applications/" + this.editedItem.id });
    },
    editContact(item) {
      this.editedItem = Object.assign({}, item.contact);
      this.editedItem.contactTypeId = item.contactTypeId;
      this.editedItem.locationContactId = item.id;
      this.editContactModal = true;
    },
    saveContact(item) {
      Api()
        .put("/contacts/" + this.editedItem.id, {
          name: this.editedItem.name,
          surname: this.editedItem.surname,
          idNumber: this.editedItem.idNumber,
          mobileNumber: this.editedItem.mobileNumber,
          telephoneNumber: this.editedItem.telephoneNumber,
          emailAddress: this.editedItem.emailAddress,
          password: this.editedItem.password,
          permissions: this.editedItem.permissions,
          isActive: this.editedItem.isActive
        })
        .then(
          Api()
            .put("/LocationContact/" + this.editedItem.locationContactId, {
              locationId: this.$route.params.locationId,
              contactId: this.editedItem.id,
              contactTypeId: this.editedItem.contactTypeId,
              isDeleted: false,
              isActive: true
            })
            .then(response => {
              this.getContacts(), (this.editContactModal = false);
            })
        );
    },
    saveNewServiceAccount() {
      let proceed = true;
      if (this.customerId == "" || this.customerId == null) {
        proceed = false;
        confirm("Please select a customer.");
      }
      if (this.editedItem.vlanId == "" || this.editedItem.vlanId == null) {
        proceed = false;
        confirm("Please select a vlan.");
      }
      if (
        this.editedItem.locationId == "" ||
        this.editedItem.locationId == null
      ) {
        proceed = false;
        confirm("Please select a location.");
      }
      if (
        this.editedItem.packagesIspId == "" ||
        this.editedItem.packagesIspId == null
      ) {
        proceed = false;
        confirm("Please select an ISP package.");
      }
      if (
        this.editedItem.authenticationType == "" ||
        this.editedItem.authenticationType == null
      ) {
        proceed = false;
        confirm("Please select an authentication type.");
      }
      if (proceed == true) {
        this.editedItem.serviceAccountIdentifier =
          Math.floor(Math.random() * 1000000000000) + 1;
        if (
          (this.editedItem.initialActivation === null &&
            this.editedItem.ispActivationDate !== null) ||
          this.editedItem.fnoActivationDate !== null
        ) {
          if (
            new Date(this.editedItem.ispActivationDate) >
            new Date(this.editedItem.fnoActivationDate)
          ) {
            this.editedItem.initialActivation = this.editedItem.ispActivationDate;
          } else {
            this.editedItem.initialActivation = this.editedItem.fnoActivationDate;
          }
        }
        if (
          this.editedItem.authenticationType === "IPoE" &&
          this.editedItem.IPoEMacAddress === null
        ) {
          this.editedItem.IPoEActive = false;
        } else if (
          this.editedItem.authenticationType === "IPoE" &&
          this.editedItem.IPoEMacAddress !== null
        ) {
          this.editedItem.IPoEActive = true;
        }
        let deviceId = this.editedItem.deviceId;
        let locationId = this.editedItem.locationId;
        Api()
          .post("/serviceAccounts", {
            serviceAccountIdentifier: this.editedItem.serviceAccountIdentifier.toString(),
            authenticationType: this.editedItem.authenticationType,
            pppoeUsername: this.editedItem.pppoeUsername || null,
            pppoePassword: this.editedItem.pppoePassword || null,
            IPoEMacAddress: this.editedItem.IPoEMacAddress,
            fnoActivationDate: this.editedItem.fnoActivationDate || null,
            fnoDeactivationDate: this.editedItem.fnoDeactivationDate || null,
            initialActivation: this.editedItem.initialActivation || null,
            ispActivationDate: this.editedItem.ispActivationDate || null,
            ispDeactivationDate: this.editedItem.ispDeactivationDate || null,
            staticIpv4: this.editedItem.staticIpv4 || null,
            staticIpv6: this.editedItem.staticIpv6 || null,
            deviceId: this.editedItem.deviceId,
            locationId: this.editedItem.locationId,
            packagesIspId: this.editedItem.packagesIspId,
            vlanId: this.vlanId,
            IPoEActive: this.editedItem.IPoEActive || null,
            isChange: false,
            isDeleted: this.editedItem.isDeleted,
            isActive: this.editedItem.isActive
          })
          .then(response => {
            if (deviceId !== null) {
              Api().put("/devices/" + deviceId, {
                locationId: locationId,
                locationNetworkId: this.selectedLocation.locationNetworkId,
                locationNodeId: this.selectedLocation.locationNetwork
                  .locationNodeId,
                switchingCentreId: this.selectedLocation.locationNetwork
                  .locationNode.switchingCentreId
              });

              Api().put("/locations/" + locationId, {
                equipmentInstalled: true
              });
            } else {
              Api().put("/locations/" + locationId, {
                equipmentInstalled: false
              });
            }
            this.$emit("serviceAccountsSaved");
            this.fetchServiceAccounts();
            const route = { name: this.$route.name };
            route.query = route.query = {};
            this.$router.push(route);
            this.editedItem.vlanId = null;
            this.customerId = null;
          });
        this.close();
      }
    },
    viewDeviceDetails(item){
      // this.$router.push('http://acs.fibregeeks.co.za/live/AXCustomerSupportPortal/#/cpe/cpeid/'+item.ponMac+'?hide_header=1&tab=CpeOverview');
      this.$router.push({ path: "/devices/" + item.id });
    },
    saveNewContact() {
      Api()
        .post("/contacts", {
          name: this.editedItem.name,
          surname: this.editedItem.surname,
          idNumber: this.editedItem.idNumber,
          mobileNumber: this.editedItem.mobileNumber,
          telephoneNumber: this.editedItem.telephoneNumber,
          emailAddress: this.editedItem.emailAddress,
          password: this.editedItem.password,
          permissions: this.editedItem.permissions,
          isActive: true
        })
        .then(response => {
          if(response.status === 200){
            this.text = "Contact Successfully created!";
          this.snackbar = true;
          this.getContacts(), this.addLocationContact(response.data);
          } else {
            this.errorText = "Error: "+response.parent.sqlMessage
          this.errorSnackbar = true;
          }
          
        });
    },
    fetchAllContacts() {
      Api()
        .get("/contacts")
        .then(response => {
          this.allContacts = response.data;
        });
    },
    addLocationContact(item) {
      Api()
        .post("/LocationContact", {
          locationId: this.$route.params.locationId,
          contactId: item.id,
          contactTypeId: this.editedItem.contactTypeId,
          isDeleted: false,
          isActive: true
        })
        .then(response => {
          this.getContacts(),
            (this.addContactModal = false),
            (this.createContactModal = false);
        });
    },
    async routeDevice(item){
      // let url =item
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/devices/:deviceId'})
        if(route.length>0){
      await this.$store.dispatch('setCurrentRoute', route[0])
      this.$router.push({ path: "/devices/" + item.id });
        } else {
          confirm('You do not have access to this module. Please request access from your admin.')
        }
    },
    saveDevice() {
      if (typeof this.selectedDevice != "undefined") {
        this.editedItem.upstreamDeviceId = this.selectedDevice[0].id;
      }
      let proceed = true;
      if (
        this.deviceMakeModelId == null ||
        typeof this.deviceMakeModelId === "undefined"
      ) {
        proceed = false;
        confirm("Please select a device make model.");
      }
      if (proceed == true) {
        Api()
          .put("/devices/" + this.editedItem.id, {
            systemName: this.editedItem.systemName,
            ipAddress: this.editedItem.ipAddress,
            serialNumber: this.editedItem.serialNumber,
            ponMac: this.editedItem.ponMac,
            macAddress: this.editedItem.macAddress,
            ponNumerical: this.editedItem.ponNumerical,
            productNumber: this.editedItem.productNumber,
            deviceMakeModelId: this.editedItem.deviceMakeModelId,
            locationId: this.$route.params.locationId,
            locationNetworkId: this.locationNetworkId,
            locationNodeId: this.locationNodeId,
            switchingCentreId: this.switchingCentreId,
            port: this.editedItem.port,
            slot: this.editedItem.slot,
            frame: this.editedItem.frame,
            note: this.editedItem.note,
            upstreamDeviceId: this.editedItem.upstreamDeviceId,
            ponId: this.editedItem.ponId,
            isDeleted: this.editedItem.isDeleted,
            isActive: this.editedItem.isActive
          })
          .then(response => {
            this.$emit("devicesSaved");
            this.getDevices();
          });
        this.$emit("devicesSaved");
        this.close();
        this.locationtab = false;
        this.getDevices();
      }
    },

    saveNewDevice() {
      if (typeof this.selectedDevice[0] != "undefined")
        this.editedItem.upstreamDeviceId = this.selectedDevice[0].id;
      let proceed = true;
      if (this.deviceMakeModelId == null) {
        proceed = false;
        confirm("Please select a device make model.");
      }
      if (proceed == true) {
        Api()
          .post("/devices", {
            systemName: this.editedItem.systemName,
            ipAddress: this.editedItem.ipAddress,
            serialNumber: this.editedItem.serialNumber,
            ponMac: this.editedItem.ponMac,
            macAddress: this.editedItem.macAddress,
            ponNumerical: this.editedItem.ponNumerical,
            productNumber: this.editedItem.productNumber,
            deviceMakeModelId: this.editedItem.deviceMakeModelId,
            locationId: this.$route.params.locationId,
            locationNetworkId: this.locationNetworkId,
            locationNodeId: this.locationNodeId,
            switchingCentreId: this.switchingCentreId,
            port: this.editedItem.port,
            slot: this.editedItem.slot,
            frame: this.editedItem.frame,
            note: this.editedItem.note,
            upstreamDeviceId: this.editedItem.upstreamDeviceId,
            ponId: this.editedItem.ponId,
            isDeleted: this.editedItem.isDeleted,
            isActive: this.editedItem.isActive
          })
          .then(response => {
            this.$emit("devicesSaved");
            this.getDevices();
          });
        this.$emit("devicesSaved");

        this.close();
      }
      this.getDevices();
    },
    saveInstallation() {
      if (
        this.installation.patchLead &&
        this.installation.ftthBox &&
        this.installation.labelling &&
        this.installation.mstConnection
      ) {
        this.installation.passiveInstallComplete = true;
      } else {
        this.installation.passiveInstallComplete = false;
      }
      if (
        this.installation.activeDataReading &&
        this.installation.activeVideoReading &&
        this.installation.connectionName &&
        this.installation.connectionPassword
      ) {
        this.installation.activeInstallComplete = true;
      } else {
        this.installation.activeInstallComplete = false;
      }
      Api()
        .post("/installations", {
          patchLead: this.installation.patchLead,
          ftthBox: this.installation.ftthBox,
          labelling: this.installation.labelling,
          mstConnection: this.installation.mstConnection,
          passiveDataReading: this.installation.passiveDataReading,
          passiveVideoReading: this.installation.passiveVideoReading,
          activeDataReading: this.installation.activeDataReading,
          activeVideoReading: this.installation.activeVideoReading,
          connectionName: this.installation.connectionName,
          connectionPassword: this.installation.connectionPassword,
          timeStamp: new Date(),
          locationId: this.$route.params.locationId,
          isActiveInstall: this.installation.isActiveInstall,
          isPassiveInstall: this.installation.isPassiveInstall,
          activeInstallComplete: this.installation.activeInstallComplete,
          passiveInstallComplete: this.installation.passiveInstallComplete,
          isActive: this.installation.isActive,
          isDeleted: this.installation.isDeleted
        })
        .then(response => {
          if (this.installation.isPassiveInstall == true) {
            Api().put("/locations/" + this.$route.params.locationId, {
              fibrePulled: this.installation.passiveInstallComplete
            });
          }
          if (this.installation.isActiveInstall == true) {
            Api().put("/locations/" + this.$route.params.locationId, {
              equipmentInstalled: this.installation.activeInstallComplete
            });
          }
          this.installation = Object.assign({}, this.defaultInstallation);
          this.fetchInstallations(),
            this.getLocationInfo(),
            (this.addInstallationModal = false);
        });
    },
    editItem(item) {
      this.fetchComments(item.id);
      this.editedItem = Object.assign({}, item);

      this.editedItem.upstreamDeviceId = null;
      this.selectedDevice = [];

      if (item.upstreamDeviceId !== null) {
        this.addButton = false;
        this.editedItem.upstreamDeviceId = item.upstreamDeviceId;
        Api()
          .get(
            "/devices/searchByUpstreamDevice/" +
              this.editedItem.upstreamDeviceId
          )
          .then(response => {
            this.selectedDevice[0] = response.data[0];
            return;
          });
      } else {
        this.addButton = true;
      }
      this.editDeviceModal = true;
    },
    fetchDate() {
      this.editedCommentItem.dateTimeStamp = new Date()
        .toISOString()
        .substr(0, 10);
      return this.formatDate(this.editedCommentItem.dateTimeStamp);
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    addComment() {
      let proceed = true;

      if (this.editedCommentItem.comments == "") {
        proceed = false;
        confirm("Please enter a comment.");
      }
      this.fetchDate();
      if (proceed == true) {
        Api()
          .post("/deviceComments", {
            contactId: this.$store.state.user.id,
            dateTimeStamp: this.editedCommentItem.dateTimeStamp,
            comments: this.editedCommentItem.comments,
            deviceId: this.editedItem.id,
            isDeleted: this.editedCommentItem.isDeleted,
            isActive: this.editedCommentItem.isActive
          })
          .then(response => {
            this.fetchComments(this.editedItem.id);
          });
        this.addCommentDialog = false;
      }
    },
    editComment(item) {
      this.fetchComments(this.editedItem.id);
      this.editedCommentItem = Object.assign({}, item);
      this.editCommentDialog = true;
    },
    saveComment() {
      let proceed = true;

      if (this.editedCommentItem.comments == "") {
        proceed = false;
        confirm("Please enter a comment.");
      }
      this.fetchDate();
      if (proceed == true) {
        Api()
          .put("/deviceComments/" + this.editedCommentItem.id, {
            contactId: this.$store.state.user.id,
            dateTimeStamp: this.editedCommentItem.dateTimeStamp,
            comments: this.editedCommentItem.comments,
            deviceId: this.editedItem.id,
            isDeleted: this.editedCommentItem.isDeleted,
            isActive: this.editedCommentItem.isActive
          })
          .then(response => {
            this.fetchComments(this.editedItem.id);
          });
        this.editCommentDialog = false;
      }
    },
    deleteComment(id) {
      confirm("Are you sure you want to delete this item?") &&
        Api()
          .put("/deviceComments/" + id, {
            isActive: false,
            isDeleted: true
          })
          .then(response => {
            this.fetchComments(this.editedItem.id);
            this.initialize();
          });
    },
    fetchComments(id) {
      (this.loading = true),
        Api()
          .get("/deviceComments/findbyDevice/" + id)
          .then(response => {
            this.deviceComments = response.data;
            this.loading = false;
          });
    },
    async deviceCount(){
      await Api()
      .get('/devices/active/count')
      .then(response=>{
          this.devicePagination.totalItems = response.data.count;
          // console.log(this.devicePagination)
          // debugger
      })
    },
    async initialize() {
      // this.fetchUnusedDevices();
      this.deviceCount()
      this.fetchDocuments();
      this.fetchInstallations();
      // this.fetchAllContacts();
      this.fetchContactTypes();
      this.fetchDeviceMakeModels();
      this.getLocationInfo();
      this.getContacts();
      this.getServiceAccounts();
      this.setActiveTabName("summary");
      this.getDevices();
      this.getTransactions();
      this.fetchDate();
      // this.fetchUpstreamDevices();
      this.fetchApplications();
      this.LocationDetailLoading=false
      this.fetchOrgContacts();
      this.fetchTicketTemplates();
        this.fetchTicketCategories();
      this.fetchTicketCategoryItems();
      this.fetchTickets()
      // this.fetchCustomers();
    },
        fetchOrgContacts() {
      this.filteredUsers = [];
      Api()
        .get("/organisationContact")
        .then(async response => {
          this.filteredUsers = response.data.filter(function(el) {
            return el.userType !== "endClient";
          });
          let contactArray = await this.filteredUsers.map(x => x.contact);
          this.filteredUsers = contactArray;
        });
    },
    fetchTicketTemplates() {
      Api()
        .get("/ticketTemplate")
        .then(response => {
          this.ticketTemplates = response.data;
        });
    },
    fetchApplications(){
      Api()
      .get('/applications/byLocation/'+this.$route.params.locationId)
      .then(response=>{
        this.applications = response.data.sort()
      })
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    displayInstallContents(name) {
      return this.activeInstallTab === name;
    },
    setActiveInstallTabName(name) {
      this.activeInstallTab = name;
    },
    search(search) {
      if (search.search !== "") {
        Api()
          .get("/installations", {
            params: {
              search: search.search
            }
          })
          .then(response => {
            this.installations = response.data;
          });
      }
    },
    async getContacts() {
      await Api()
        .get("/LocationContact/byLocation/" + this.$route.params.locationId)
        .then(response => {
          this.Contacts = response.data;
        });
    },
    async getDevices() {
      await Api()
        .get("/devices/byLocation/" + this.$route.params.locationId)
        .then(response => {
          this.deviceSearchModal=false
          this.devices = response.data;
        });
    },
    async getServiceAccounts() {
      await Api()
        .get("/serviceAccounts/byLocation/" + this.$route.params.locationId)
        .then(response => {
          this.serviceAccounts = response.data;
        });
    },
    close() {
      this.addDevice = false;
      this.addDeviceModal = false;
      this.editDeviceModal = false;
      this.newDialog = false;
      this.dialog = false;

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async getLocationInfo() {
      await Api()
        .get("/Locations/" + this.$route.params.locationId)
        .then(response => {
          this.locationInfo = response.data[0];
          this.locationNetworkId = response.data[0].locationNetworkId;
          this.locationNodeId = response.data[0].locationNetwork.locationNodeId;
          this.switchingCentreId =
            response.data[0].locationNetwork.locationNode.switchingCentreId;
        });
    },
    formatDate(date) {
      if (date == null) {
        return null;
      } else {
        return dateformat(date, "dd/mm/yyyy");
      }
    },
    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    formatTableDate(date) {
      return dateformat(date, "dd/mm/yyyy");
    }
  }
};
</script>
<style>
.activeRow {
  background: #bdc3c7;
}
.v-chip.Live {
  background: #1ebb2c;
}
.v-chip.Progress {
  background: #df5f09;
}
.v-chip.Planned {
  background: #0580e6;
}
</style>
